import { useEffect, useState } from "react";
import printJS from 'print-js';
import NocService from "./NocService";
import ApiClient from "../http/ApiClient";
import Url from "../http/Url";
import ModalComp from "../common/ModalComp";
import { Link } from "react-router-dom";


var apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
const NocForm = (props) => {
  const [formValues, setFormValues] = useState({});
  const [fileList, setFileList] = useState([]);
  const [ddoFileList, setDdoFileList] = useState([]);
  const [action, setAction] = useState([]);
  const [pdfUrl, setPdfUrl] = useState([]);
  const [pdfView, setPdfView] = useState(false);
  const [readOnly, setReadOnly] = useState(false);
  const [currentDate, setCurrentDate] = useState('');
  const [currentDateRej, setCurretDateRej] = useState('');
  const [pdfForDownload, setPdfForDownload] = useState("");
  const [uploadedFiles, setUploadedFiles] = useState(new Set());




  const pdfViewClosed = () => { setPdfView(false); }
  const today = new Date();
  const eighteenYearsAgo = new Date(today);
  eighteenYearsAgo.setFullYear(today.getFullYear() - 18);
  const maxDate = eighteenYearsAgo.toISOString().split('T')[0];


  useEffect(() => {
    const { periodOfVisitStartDate, periodOfVisitEndDate } = formValues;

    // Only calculate duration if both dates are provided
    if (periodOfVisitStartDate && periodOfVisitEndDate) {
      const startDate = new Date(periodOfVisitStartDate);
      const endDate = new Date(periodOfVisitEndDate);

      // Calculate the duration in days
      const durationInMs = endDate - startDate;
      const durationInDays = durationInMs / (1000 * 60 * 60 * 24); // Convert milliseconds to days
      setFormValues(prevState => ({
        ...prevState,
        durationOfStayAbroad: Math.max(durationInDays, 0) // Ensure no negative duration
      }));
    }
  }, [formValues.periodOfVisitStartDate, formValues.periodOfVisitEndDate])

  useEffect(() => {
    const storedName = document.cookie
      .split('; ')
      .find(row => row.startsWith('name='))
      ?.split('=')[1];

    const storedDesignation = document.cookie
      .split('; ')
      .find(row => row.startsWith('designation='))
      ?.split('=')[1];

    //  const todayDate = new Date().toISOString().split('T')[0];
    const todayDate = new Date();
    setCurretDateRej(todayDate.toISOString().split('T')[0]);
    todayDate.setDate(todayDate.getDate() + 15);
    const futureDate = todayDate.toISOString().split('T')[0];
    setCurrentDate(futureDate);

    if (storedName && storedDesignation) {
      const nameWithDesg = `${storedName} (${storedDesignation})`;


      setFormValues(prevState => ({
        ...prevState,
        nameWithDesg: nameWithDesg
      }));
    }


    if (props.passportNo != undefined) {
      NocService.getNocByPass(props.passportNo).then((result) => {
        result["createdBy"] = 1;
        setFormValues(result);

      });
    }

    else if (props.application.applicationId != undefined) {  // ref Id is equivalent to application ID
      NocService.getNocById(props.application.applicationId).then((result) => {
        setFormValues(result);
      });
    }

    else if (props.application.refId != undefined) {  // ref Id is equivalent to application ID
      NocService.getNocById(props.application.refId).then((result) => {
        let fileList = [...result.fileList];
        result["fileList"] = [...fileList];
        result["createdBy"] = 1;
        setFormValues(result);
      });
    }
    if (props.application?.processTaskId != undefined) {
      NocService.getActionForTask(props.application?.processTaskId).then((result) => {
        setAction(result);
      });
    }

    const userRole = sessionStorage.getItem('userRole');
    if (userRole) {
      setReadOnly(true);
    }

  }, [props.applicationId]);

  const saveData = () => {

    const purposeOfVisit = document.getElementById('purposeOfVisit');
    if (!purposeOfVisit || purposeOfVisit.value.trim() === '') {
      alert("The purpose of the visit to abroad is mandatory.");
      return;
    }

    const visitPurpose = document.getElementById('courseOfStudy');
    if (!visitPurpose || visitPurpose.value.trim() === '') {
      alert("Explain visit purpose is mandatory.");
      return;
    }

    const dob = document.getElementById('dob');
    if (!dob || dob.value.trim() === '') {
      alert("Date of Birth is mandatory.");
      return;
    }

    const doa = document.getElementById('dateOfAppointment');
    if (!doa || doa.value.trim() === '') {
      alert("Date of Appointment is mandatory.");
      return;
    }

    const duration = document.getElementById('durationOfStayAbroad');
    if (!duration || duration.value.trim() === '') {
      alert("Duration of stay is mandatory.");
      return;
    }

    const periodOfVisitStartDate = document.getElementById('periodOfVisitStartDate');
    if (!periodOfVisitStartDate || periodOfVisitStartDate.value.trim() === '') {
      alert("Period of start date is mandatory");
      return;
    }

    const periodOfVisitEndDate = document.getElementById('periodOfVisitEndDate');
    if (!periodOfVisitEndDate || periodOfVisitEndDate.value.trim() === '') {
      alert("Period of Visit end date is mandatory");
      return;
    }


    const durationValue = parseInt(duration.value, 10);
    if (isNaN(durationValue) || durationValue <= 0) {
      alert("Invalid duration of stay abroad.");
      return;
    }

    // Parse start date
    const startDate = new Date(periodOfVisitStartDate.value);
    if (isNaN(startDate.getTime())) {
      alert("Invalid start date.");
      return;
    }

    // Calculate end date based on start date and duration
    const calculatedEndDate = new Date(startDate);
    calculatedEndDate.setDate(startDate.getDate() + durationValue);

    // Format calculated end date to 'yyyy-mm-dd'
    const formattedEndDate = calculatedEndDate.toISOString().split('T')[0];

    // Check if the provided end date matches the calculated end date
    if (periodOfVisitEndDate.value !== formattedEndDate) {
      alert(`End date must be ${formattedEndDate} for a stay of ${durationValue} days.`);
      return;
    }

    const selectedByApps = formValues.selectedByApps; // Get the value from state

    if (selectedByApps === 'Yes') {
      // Check if 'Year of Selection' is filled
      const yearOfSelection = formValues.yearOfSelection?.trim();
      if (!yearOfSelection || yearOfSelection === '') {
        alert("Year of Selection is mandatory.");
        return;
      }

      // Check if 'Serial Number of Selection' is filled
      // const snoOfSelection = formValues.snoOfSelection?.trim();
      // if (!snoOfSelection || snoOfSelection === '') {
      //   alert("Serial Number of Selection is mandatory.");
      //   return;
      // }
    } else {
      // Check if 'Mode of recruitment' is filled when APPSC/TGPSC is not applicable
      const notUnderAppscPreview = formValues.notUnderAppscPreview?.trim();
      if (!notUnderAppscPreview || notUnderAppscPreview === '') {
        alert("Mode of recruitment if not under APPSC/TGPSC is mandatory.");
        return;
      }
    }

    // const selectedByApps = document.getElementById('switchStatus1').innerText;
    // if (selectedByApps === 'Yes') {
    //   const yearOfSelection = document.getElementById('yearOfSelection');
    //   if (!yearOfSelection || yearOfSelection.value.trim() === '') {
    //     alert("Year of Selection is mandatory.");
    //     return;
    //   }

    //   const snoOfSelection = document.getElementById('snoOfSelection');
    //   if (!snoOfSelection || snoOfSelection.value.trim() === '') {
    //     alert("Serial Number of Selection is mandatory.");
    //     return;
    //   }
    // } else {
    //   const notUnderAppscPreview = document.getElementById('notUnderAppscPreview');
    //   if (!notUnderAppscPreview || notUnderAppscPreview.value.trim() === '') {
    //     alert("Mode of recruitment if not under APPSC/TGPSC is mandatory.");
    //     return;
    //   }
    // }

    // const employmentVoucher = document.getElementById('switchStatus2').innerText;
    // if (employmentVoucher === 'Yes') {
    //   const employmentVoucherRemarks = document.getElementById('employmentVoucherRemarks');
    //   if (!employmentVoucherRemarks || employmentVoucherRemarks.value.trim() === '') {
    //     alert("Employment Voucher details are mandatory.");
    //     return;
    //   }
    // }

    const employmentVoucher = formValues.employmentVoucher;
    if (employmentVoucher === 'Yes') {
      const employmentVoucherRemarks = document.getElementById('employmentVoucherRemarks');
      if (!employmentVoucherRemarks || employmentVoucherRemarks.value.trim() === '') {
        alert("Employment Voucher details are mandatory.");
        return;
      }
    }

    // const workUnderGovPriv = document.getElementById('switchStatus3').innerText;
    // if (workUnderGovPriv === 'Yes') {
    //   const workUnderGovPrivRemarks = document.getElementById('workUnderGovPrivRemarks');
    //   if (!workUnderGovPrivRemarks || workUnderGovPrivRemarks.value.trim() === '') {
    //     alert("Appointment order of the institution details are mandatory.");
    //     return;
    //   }
    // }

    const workUnderGovPriv = formValues.workUnderGovPriv;
    if (workUnderGovPriv === 'Yes') {
      const workUnderGovPrivRemarks = document.getElementById('workUnderGovPrivRemarks');
      if (!workUnderGovPrivRemarks || workUnderGovPrivRemarks.value.trim() === '') {
        alert("Appointment order of the institution details are mandatory.");
        return;
      }
    }




    // const pensionTerminalGratuity = document.getElementById('switchStatus4').innerText;
    // if (pensionTerminalGratuity === 'Yes') {
    //   const pensionTerminalGratuityRemarks = document.getElementById('pensionTerminalGratuityRemarks');
    //   if (!pensionTerminalGratuityRemarks || pensionTerminalGratuityRemarks.value.trim() === '') {
    //     alert("Details of Pension Contribution & Terminal Gratuity are mandatory.");
    //     return;
    //   }
    // }

    const pensionTerminalGratuity = formValues.pensionTerminalGratuity;
    if (pensionTerminalGratuity === 'Yes') {
      const pensionTerminalGratuityRemarks = document.getElementById('pensionTerminalGratuityRemarks');
      if (!pensionTerminalGratuityRemarks || pensionTerminalGratuityRemarks.value.trim() === '') {
        alert("Details of Pension Contribution & Terminal Gratuity are mandatory.");
        return;
      }
    }


    // Check for Early Leave
    // const earlyLeave = document.getElementById('switchStatus5').innerText;
    // if (earlyLeave === 'Yes') {
    //   const earlyLeaveRemarks = document.getElementById('earlyLeaveRemarks');
    //   if (!earlyLeaveRemarks || earlyLeaveRemarks.value.trim() === '') {
    //     alert("Details of earlier leave for higher studies are mandatory.");
    //     return;
    //   }
    // }

    const earlyLeave = formValues.earlyLeave;
    if (earlyLeave === 'Yes') {
      const earlyLeaveRemarks = document.getElementById('earlyLeaveRemarks');
      if (!earlyLeaveRemarks || earlyLeaveRemarks.value.trim() === '') {
        alert("Details of earlier leave for higher studies are mandatory.");
        return;
      }
    }

    const periodOfAvailment = formValues.periodOfAvailment;
    if (periodOfAvailment === 'Yes') {
      const periodOfAvailmentRemarks = document.getElementById('periodOfAvailmentRemarks');
      if (!periodOfAvailmentRemarks || periodOfAvailmentRemarks.value.trim() === '') {
        alert("Details of the period of availment of leave are mandatory.");
        return;
      }
    }

    const conditionOfBond = formValues.conditionOfBond;
    if (conditionOfBond === 'Yes') {
      const conditionOfBondRemarks = document.getElementById('conditionOfBondRemarks');
      if (!conditionOfBondRemarks || conditionOfBondRemarks.value.trim() === '') {
        alert("Details of the bond condition are mandatory.");
        return;
      }
    }

    const regularisedEarlyLeave = formValues.regularisedEarlyLeave;
    if (regularisedEarlyLeave === 'Yes') {
      const regularisedEarlyLeaveRemarks = document.getElementById('regularisedEarlyLeaveRemarks');
      if (!regularisedEarlyLeaveRemarks || regularisedEarlyLeaveRemarks.value.trim() === '') {
        alert("A copy of the order for regularized early leave is mandatory.");
        return;
      }
    }


    const fulfillConditionOfBond = formValues.fulfillConditionOfBond;
    if (fulfillConditionOfBond === 'Yes') {
      const fulfillConditionOfBondRemarks = document.getElementById('fulfillConditionOfBondRemarks');
      if (!fulfillConditionOfBondRemarks || fulfillConditionOfBondRemarks.value.trim() === '') {
        alert("Details of fulfillment of bond conditions are mandatory.");
        return; // Stops form submission if validation fails
      }
    }


    const eol = formValues.eol;
    if (eol === 'Yes') {
      const eolRemarks = document.getElementById('eolRemarks');
      if (!eolRemarks || eolRemarks.value.trim() === '') {
        alert("Details of willingness to proceed abroad on EOL are mandatory.");
        return;
      }
    }

    const executionOfBond = formValues.executionOfBond;
    if (executionOfBond === 'Yes') {
      const executionOfBondRemarks = document.getElementById('executionOfBondRemarks');
      if (!executionOfBondRemarks || executionOfBondRemarks.value.trim() === '') {
        alert("Details of willingness to execute a bond are mandatory.");
        return;
      }
    }

    const pendingCharges = formValues.pendingCharges;
    if (pendingCharges === 'Yes') {
      const pendingChargesRemarks = document.getElementById('pendingChargesRemarks');
      if (!pendingChargesRemarks || pendingChargesRemarks.value.trim() === '') {
        alert("Details of pending charges/dues are mandatory.");
        return;
      }
    }

    // Check for Drawn Educational Loan
    const drawnEducationalLoan = formValues.drawnEducationalLoan;
    if (drawnEducationalLoan === 'Yes') {
      const drawnEducationalLoanRemarks = document.getElementById('drawnEducationalLoanRemarks');
      if (!drawnEducationalLoanRemarks || drawnEducationalLoanRemarks.value.trim() === '') {
        alert("Details of drawn interest-free educational loans are mandatory.");
        return;
      }
    }


    const repaymentOfLoan = formValues.repaymentOfLoan;
    if (repaymentOfLoan === 'Yes') {
      const repaymentOfLoanRemarks = document.getElementById('repaymentOfLoanRemarks');
      if (!repaymentOfLoanRemarks || repaymentOfLoanRemarks.value.trim() === '') {
        alert("Details of repayment or outstanding amount are mandatory.");
        return;
      }
    }

    const drawnOfGovernmentLoans = formValues.drawnOfGovernmentLoans;
    if (drawnOfGovernmentLoans === 'Yes') {
      const drawnOfGovernmentLoansRemarks = document.getElementById('drawnOfGovernmentLoansRemarks');
      if (!drawnOfGovernmentLoansRemarks || drawnOfGovernmentLoansRemarks.value.trim() === '') {
        alert("Details of drawn government loans are mandatory.");
        return;
      }
    }

    // Check for Service in Rural Areas
    const servedInRuralAreas = formValues.servedInRuralAreas;
    if (servedInRuralAreas === 'Yes') {
      const servedInRuralAreasRemarks = document.getElementById('servedInRuralAreasRemarks');
      if (!servedInRuralAreasRemarks || servedInRuralAreasRemarks.value.trim() === '') {
        alert("Details of service in rural areas are mandatory.");
        return;
      }
    }

    const permanaentAddress = document.getElementById('permanentAddress');
    if (!permanaentAddress || permanaentAddress.value.trim() === '') {
      alert("Permanent Address is mandatory.");
      return;
    }
    const addressAbroad = document.getElementById('addressAbroad');
    if (!addressAbroad || addressAbroad.value.trim() === '') {
      alert("Abroad Address is mandatory.");
      return;
    }

    const cityOfVisitAborad = document.getElementById('cityOfVisitAborad');
    if (!cityOfVisitAborad || cityOfVisitAborad.value.trim() === '') {
      alert("City of visit is mandatory")
      return;
    }

    const countryOfvisitAbroad = document.getElementById('countryOfvisitAbroad');
    if (!countryOfvisitAbroad || countryOfvisitAbroad.value.trim() === '') {
      alert("Country of visit is mandatory")
      return;
    }

    const stoodAnyPersonWentAbroad = formValues.stoodAnyPersonWentAbroad;
    if (stoodAnyPersonWentAbroad === 'Yes') {
      const stoodAnyPersonWentAbroadRemarks = document.getElementById('stoodAnyPersonWentAbroadRemarks');
      if (!stoodAnyPersonWentAbroadRemarks || stoodAnyPersonWentAbroadRemarks.value.trim() === '') {
        alert("Details of standing as a surety are mandatory.");
        return;
      }
    }

    const fieldDescriptions = {
      '1': 'Employee Request Letter',
      '2': 'Copy of Passport',
      '3': 'Surety Bond',
      '5': 'Certificate of Head of Department/Institution',
      '6': 'No Charge Pending',
      '7': 'Service Satisfactory Certificate',
      '8': 'No Dues Certificate',
      '9': 'Copy of Service Regularization And Probation Declaration',
      '10': 'DDO Covering Letter',
      '18': 'Certificate by The First Surety',
      '19': 'Latest Payslip of the First Surety',
      '20': 'Certificate by The Second Surety',
      '21': 'Latest Payslip of the Second Surety'
    };

    const mandatoryFields = ['1', '2', '3', '5', '6', '7', '8', '9', '10', '18', '19', '20', '21'];


    for (const id of mandatoryFields) {
      const file = document.getElementById(id);
      console.log("formValues.serviceStatus", formValues.serviceStatus);
      if (formValues.serviceStatus === 'yes' && id === '9') {
        console.log("formValues.serviceStatus", formValues.serviceStatus);
      }
      // General check for all other fields
      else {
        if (!file || !file.files || file.files.length === 0) {
          const description = fieldDescriptions[id] || `Field ${id}`;
          alert(`Please upload a file for ${description}.`);
          return;
        }
      }
    }

    // for (const id of mandatoryFields) {
    //   const file = document.getElementById(id);
    //   if (!file || !file.files || file.files.length === 0) {
    //     const description = fieldDescriptions[id] || `Field ${id}`;
    //     alert(`Please upload a file for ${description}.`);
    //     return;
    //   }
    // }


    const userConfirmed = window.confirm("Are you sure you want to submit your application?");
    if (userConfirmed) {
      NocService.saveNoc(formValues).then((result) => {
        alert("Your application has been submitted successfully with the application number " + result.applicationNumber);
        props.callBack();
      });
    } else {
      alert("Submission cancelled.");
    }


  }
  const saveApproveData = () => {
    if (sessionStorage.getItem('userRole') === 'CD32') {
      formValues.remarks = '';
      formValues.actionId = '1';
    }

    if (formValues.durationOfStayAbroad <= 30 && sessionStorage.getItem('userRole') === 'CD3') {
      let confirmed = false;
      if (formValues.actionId === '2') {
        confirmed = window.confirm(`Are you sure you want to give final approval with Application number ${formValues.applicationNumber} with noc abroad travel?`);
      }
      else if (formValues.actionId === '3') {
        confirmed = window.confirm(`Are you sure you want to Revert with Application number ${formValues.applicationNumber} with noc abroad travel?`);
      }
      else if (formValues.actionId === '4') {
        confirmed = window.confirm(`Are you sure you want to Return with Application number ${formValues.applicationNumber} with noc abroad travel?`);
      }

      if (!confirmed) {
        return;
      }
    }



    const remarksField = document.getElementById('roleWiseRemarks');
    if ((!remarksField || remarksField.value.trim() === '') && sessionStorage.getItem('userRole') !== 'CD32') {
      alert("Remarks is mandatory.");
      return;
    }

    const selectedRadio = document.querySelector('input[name="actionId"]:checked');
    if (!selectedRadio && sessionStorage.getItem('userRole') !== 'CD32') {
      alert("Please select an action.");
      return;
    }

    if (sessionStorage.getItem('userRole') === 'CD3') {
      const fileId = formValues.durationOfStayAbroad > 30 ? "13" : "25";
      const fileInput = document.getElementById(fileId);
      if ((!fileInput || !fileInput.files || fileInput.files.length === 0 && formValues.durationOfStayAbroad <= 30)) {
        if (formValues.actionId === '2') {
          alert('Please upload a file for Attach final Noc Approval');
          return;
        }

      }
    }

    if (sessionStorage.getItem('userRole') === 'CD32') {
      const fileInput = document.getElementById('25');
      if (!fileInput.files.length) {
        alert("Please upload the required file.");
        return;
      }

    }

    let data = {
      "processTaskId": props.application.processTaskId,
      "createId": sessionStorage.getItem("user"),
      "processRequestId": props.application.processRequestId,
      "refId": props.application.refId,
      "nocId": props.application.refId,
      "action": formValues.actionId,
      "remarks": formValues.remarks,
      "ddoFileList": ddoFileList
    }

    NocService.saveApproval(data).then((result) => {
      alert("Your response is submitted successfully.");
      props.callBack();
    });
  }
  const handleInput = (event) => {
    var { name, value } = event.target;
    if (name === 'snoOfSelection') {
      if (value !== '' && !/^\d+$/.test(value)) {
        alert('Serial number must be numeric.');
        return;
      }
    }
    if (event.target.type === "checkbox")
      value = event.target.checked ? "1" : "0";
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };
  const toggleSwitch = (buttonId, statusId, remarks, name) => {
    if (sessionStorage.getItem('user') !== null) {
      return;
    }
    var switchButton = document.getElementById(buttonId);
    var switchStatus = document.getElementById(statusId);
    var switchRemarks = document.getElementById(remarks);

    if (switchButton.classList.contains('active')) {
      switchButton.classList.remove('active');
      switchRemarks.classList.add('d-none');
      switchButton.textContent = "";
      switchStatus.textContent = "No";
      setFormValues({
        ...formValues,
        [name]: 'No',
      });
    } else {
      switchButton.classList.add('active');
      switchRemarks.classList.remove('d-none');
      switchButton.textContent = "";
      switchStatus.textContent = "Yes";
      setFormValues({
        ...formValues,
        [name]: 'Yes',
      });
    }
  }
  const handleFileUpload = (event) => {

    let file = event.target.files[0];
    if (!file) return;
    if (!['application/pdf', 'text/plain'].includes(file.type)) {
      alert("Invalid file type. Only PDF and TXT files are allowed.");
      event.target.value = '';
      return;
    }

    if (file.size > 5000 * 1024) {
      alert("File size exceeds the 5 MB limit.");
      event.target.value = '';
      return;
    }
    else if (file.size < 5 * 1024) {
      alert("File size must be at least 5 KB.");
      event.target.value = '';
      return;
    }

    if (uploadedFiles.has(file.name)) {
      alert("A file with this name has already been uploaded.");
      event.target.value = '';
      return;
    }

    setUploadedFiles(prev => new Set(prev).add(file.name));

    const formData = new FormData();
    formData.append("uploadFile", file);
    formData.append("allowedType", 'pdf,txt');
    formData.append("allowedSize", '5000');
    formData.append("module", "NOC");
    formData.append("docName", file.name);
    let userRole = sessionStorage.getItem('userRole');
    if (userRole === 'CD1' || userRole === 'CD2' || userRole === 'CD3' || userRole === 'CD4' || userRole === 'CD5' || userRole === 'CD32') {
      let list = [...ddoFileList];
      ApiClient.fileUpload(Url.DOC.UPLOAD_FILE, formData).then((result) => {
        let fileData = {
          "attachType": event.target.id,
          "documentManagementId": result
        }
        list = list.filter(item => item.attachType !== fileData.attachType);
        list.push(fileData);
        setDdoFileList([...list]);

        setFormValues({
          ...formValues,
          ["ddoFileList"]: [...list],
        });
      });

    }
    else {
      let list = [...fileList];
      ApiClient.fileUpload(Url.DOC.UPLOAD_FILE, formData).then((result) => {
        let fileData = {
          "attachType": event.target.id,
          "documentManagementId": result
        }
        list = list.filter(item => item.attachType !== fileData.attachType);
        list.push(fileData);
        setFileList([...list]);

        setFormValues({
          ...formValues,
          ["fileList"]: [...list],
        });
      });
    }



  }
  const viewPdf = (fileId) => {
    let fileUrl = NocService.pdfNocDoc(fileId);
    setPdfUrl(fileUrl);
    setPdfView(true);
  }

  const downloadPdf = async (documentManagementId) => {
    const url = NocService.pdfNocDoc(documentManagementId);

    try {
      // Fetch the PDF file
      const response = await fetch(url);
      const blob = await response.blob();
      const fileName = 'document.pdf';
      // Create a link element
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = fileName;

      // Append to body and trigger click
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Release object URL
      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error('Error downloading file:', error);
    }
  };


  const handleButtonClick = async () => {
    const fileList = formValues?.fileList || [];

    for (const file of fileList) {
      if (file?.documentManagementId) {
        try {
          const documentUrl = NocService.pdfNocDoc(file.documentManagementId);

          // Fetch the file as a Blob
          const response = await fetch(documentUrl);
          const blob = await response.blob();

          // Create a download link
          const link = document.createElement('a');
          const fileName = `document_${file.documentManagementId}.pdf`; // Dynamic naming based on file ID or any other criteria

          // Create a Blob URL and set as href
          link.href = URL.createObjectURL(blob);
          link.download = fileName;

          // Append to body and trigger download
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          // Clean up Blob URL
          URL.revokeObjectURL(link.href);

          console.log(`Download initiated for file ${file.documentManagementId}`);

          // Optional: Add a small delay to avoid overwhelming the browser
          await new Promise(resolve => setTimeout(resolve, 500));
        } catch (error) {
          console.error(`Error processing file ${file.documentManagementId}:`, error);
        }
      }
    }


  };


  const printPdf = (fileId) => {
    let documentUrl = NocService.pdfNocDoc(fileId);
    if (documentUrl) {
      printJS({
        printable: documentUrl,
        type: 'pdf',
        showModal: true
      });
    } else {
      console.error('PDF URL is not available.');
    }

    const aaa = (fileId) => {
      const fileList = formValues?.fileList || [];

      fileList.forEach((file) => {
        if (file?.documentManagementId) {
          const documentUrl = NocService.pdfNocDoc(file.documentManagementId);
          // Create an invisible link element
          const link = document.createElement('a');
          link.href = documentUrl;
          link.download = ''; // Optionally specify the filename here
          link.style.display = 'none';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      });
    };

  };



  const handleDownload = async () => {
    try {
      var pdfUrl;
      var user = sessionStorage.getItem('user');
      if (sessionStorage.getItem('userRole') === 'CD3') {
        pdfUrl = await NocService.downloadPDFForHOD(props.application.refId, user);
      } else if (sessionStorage.getItem('userRole') === 'CD32') {
        pdfUrl = await NocService.downloadPdfForVF(props.application.refId);
      }

      const link = document.createElement('a');
      link.href = pdfUrl;
      link.target = '_blank';
      link.download = 'NOC_Verification.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Download error:", error);
    }
  };

  const handleReturnDownload = async () => {
    try {
      const remarks = document.getElementById('roleWiseRemarks');
      if (!remarks || remarks.value.trim() === '') {
        alert("Fill the necessary remarks");
        return;
      }
      console.log("remarks", remarks.value);
      const pdfUrl = await NocService.downloadPdfForRej(props.application.refId, remarks);
      const link = document.createElement('a');
      link.href = pdfUrl;
      link.target = '_blank';
      link.download = 'NOC_Verification.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Download error:", error);
    }
  };





  return (
    < >
      <div className="pagetitle">
        <h1></h1>
      </div>

      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                {/* <h5 className="card-title">Proforma Particular</h5> */}



                <div className="row g-3">
                  <div className="col-md-6">
                    <label for="candidatename" className="form-label">Name of the Candidate<span className="text-danger">*</span></label>
                    <input type="text" className="form-control" onChange={handleInput} value={formValues.name} id="nameWithDesg" name="nameWithDesg" readOnly />
                  </div>
                  <div className="col-md-6">
                    <label for="candidatedesignation" className="form-label">Designation</label>
                    <input type="text" className="form-control" value={formValues.designation} onChange={handleInput} id="candidatedesignation" readOnly />
                  </div>
                  <div className="col-md-6">
                    <label for="purposevisitabroad" className="form-label">The purpose of the visit to abroad<span className="text-danger">*</span></label>
                    <input type="text" className="form-control" onChange={handleInput} value={formValues.purposeOfVisit} id="purposeOfVisit" name="purposeOfVisit" readOnly={readOnly} />
                  </div>
                  {/* Course of the study & specially
                      he/she wants to study abroad */}
                  <div className="col-md-6">
                    <label for="coursestudyspeciallywantstudyabroad" className="form-label"> Explain visit purpose <span className="text-danger">*</span></label>
                    <input type="text" className="form-control" onChange={handleInput} value={formValues.courseOfStudy} id="courseOfStudy" name="courseOfStudy" readOnly={readOnly} />
                  </div>
                  {/* <div className="col-md-4">
                    <label for="dateofbirth" className="form-label">Date of Birth <span className="text-danger">*</span></label>
                    <input type="date" className="form-control" onChange={handleInput} value={formValues.dob ? formValues.dob.split('T')[0] : ''} id="dob" name="dob" />
                  </div> */}
                  <div className="col-md-4">
                    <label htmlFor="dateofbirth" className="form-label">Date of Birth <span className="text-danger">*</span></label>
                    <input
                      type="date"
                      className="form-control"
                      onChange={(event) => {
                        handleInput(event);
                        const selectedDate = new Date(event.target.value);
                        const today = new Date();
                        let age = today.getFullYear() - selectedDate.getFullYear();
                        const monthDiff = today.getMonth() - selectedDate.getMonth();
                        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < selectedDate.getDate())) {
                          age--;
                        }
                        if (age < 18) {
                          alert("Date of Birth should be greater than 18 years.");
                        }
                      }}
                      value={formValues.dob ? formValues.dob.split('T')[0] : ''}
                      id="dob"
                      name="dob"
                      readOnly={readOnly}
                      max={maxDate}
                    />
                  </div>


                  <div className="col-md-4">
                    <label for="appointmentdate" className="form-label">Date of the Visa Appointment <span className="text-danger">*</span></label>
                    <input type="date" className="form-control" onChange={handleInput} value={formValues.dateOfAppointment ? formValues.dateOfAppointment.split('T')[0] : ''} id="dateOfAppointment" name="dateOfAppointment" min={currentDate} readOnly={readOnly} />
                  </div>
                  {/* <div className="col-md-4">
                    <label for="stayabroadduration" className="form-label">Duration of stay abroad in days <span className="text-danger">*</span></label>
                    <input type="text" className="form-control" onChange={handleInput} value={formValues.durationOfStayAbroad} id="durationOfStayAbroad" name="durationOfStayAbroad" maxLength={3} readOnly={readOnly} />
                  </div> */}

                  <div className="col-md-10">
                    <label for="periodOfVisit" className="form-label">Period of Visit:</label>
                  </div>

                  <div className="col-md-6">
                    <label for="periodOfVisitStartDate" className="form-label">Start Date <span className="text-danger">*</span></label>
                    <input type="date" className="form-control" onChange={handleInput} value={formValues.periodOfVisitStartDate ? formValues.periodOfVisitStartDate.split('T')[0] : ''} id="periodOfVisitStartDate" name="periodOfVisitStartDate" readOnly={readOnly} />
                  </div>

                  <div className="col-md-6">
                    <label for="periodOfVisitEndDate" className="form-label">End Date <span className="text-danger">*</span></label>
                    <input type="date" className="form-control" onChange={handleInput} value={formValues.periodOfVisitEndDate ? formValues.periodOfVisitEndDate.split('T')[0] : ''} id="periodOfVisitEndDate" name="periodOfVisitEndDate" readOnly={readOnly} />
                  </div>

                  <div className="col-md-4">
                    <label for="stayabroadduration" className="form-label">Duration of stay abroad in days <span className="text-danger">*</span></label>
                    <input type="text" className="form-control" onChange={handleInput} value={formValues.durationOfStayAbroad} id="durationOfStayAbroad" name="durationOfStayAbroad" maxLength={3} readOnly={readOnly} />
                  </div>

                  {/* <div className="col-md-12">
                    <div className="container-fluid p-0">
                      <div className="row">
                        <div className="col-md-10">
                          <label htmlFor="selectionserialnumber" className="form-label">Whether he/she has been selected by the APPSC/TGPSC.  <span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-2" style={{ textAlign: "right" }}>
                          <div className="switchButtonWrapper" onClick={() => toggleSwitch('switchButton1', 'switchStatus1', 'switchRemarks1', 'selectedByApps')}>
                            <button id="switchButton1" className={formValues.selectedByApps === 'Yes' ? 'switchButton active' : 'switchButton'}></button>
                            <span id="switchStatus1">{formValues.selectedByApps}</span>
                          </div>
                        </div>
                      </div>

                      <div id='switchRemarks1' className={formValues.selectedByApps === 'Yes' ? '' : 'd-none'}>
                        <div className="row">
                          <div className="col-md-6">
                            <label htmlFor="selectionyear" className="form-label">Year of Selection  <span className="text-danger">*</span></label>
                            <input type="text" className="form-control" value={formValues.yearOfSelection ? formValues.yearOfSelection.split('T')[0] : ''} onChange={handleInput} id="yearOfSelection" name="yearOfSelection" maxLength={4} inputMode="numeric" pattern="\d{4}" readOnly={readOnly}
                              onInput={(e) => {
                                e.target.value = e.target.value.replace(/[^0-9]/g, '').slice(0, 4);
                              }}

                            />
                          </div>
                          <div className="col-md-6">
                            <label htmlFor="selectionserialnumber" className="form-label">Serial Number of selection  <span className="text-danger">*</span></label>
                            <input type="text" className="form-control" value={formValues.snoOfSelection} onChange={handleInput} id="snoOfSelection" name="snoOfSelection" maxLength={8} readOnly={readOnly} />
                          </div>
                        </div>
                      </div>
                      <div className={formValues.selectedByApps === 'No' ? '' : 'd-none'}>
                        <div className="row">
                          <div className="col-md-6">
                            <label htmlFor="notUnderAppscPreview" className="form-label">If the post is not under purview of APPSC/TGPSC the mode of recruitment is to be specified <span className="text-danger">*</span></label>
                            <input type="text" className="form-control" value={formValues.notUnderAppscPreview} onChange={handleInput} id="notUnderAppscPreview" name="notUnderAppscPreview" readOnly={readOnly} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
 */}

                  <div className="col-md-12">
                    <div className="container-fluid p-0">
                      <div className="row">
                        <div className="col-md-10">
                          <label htmlFor="selectionserialnumber" className="form-label">
                            Whether he/she has been selected by the APPSC/TGPSC.
                            <span className="text-danger">*</span>
                          </label>
                        </div>
                        <div className="col-md-2" style={{ textAlign: "right" }}>
                          {/* Radio Buttons for Yes and No */}
                          <div className="radioButtonWrapper">
                            <label className="radio-inline">
                              <input
                                type="radio"
                                name="selectedByApps"
                                value="Yes"
                                disabled={readOnly}
                                checked={formValues.selectedByApps === 'Yes'}
                                onChange={handleInput}
                              />
                              <label htmlFor="employmentVoucherYes" className="form-label ms-0.9"> Yes</label>
                            </label>
                            <label className="radio-inline ml-3">
                              <input
                                type="radio"
                                name="selectedByApps"
                                value="No"
                                disabled={readOnly}
                                checked={formValues.selectedByApps === 'No'}
                                onChange={handleInput}
                              />
                              <label htmlFor="employmentVoucherYes" className="form-label ms-0.9"> No</label>
                            </label>
                          </div>
                        </div>
                      </div>

                      {/* Fields to show when "Yes" is selected */}
                      {formValues.selectedByApps === 'Yes' && (
                        <div className="row">
                          <div className="col-md-6">
                            <label htmlFor="selectionyear" className="form-label">
                              Year of Selection <span className="text-danger">*</span>
                              {/* <span className="text-danger">*</span> */}
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={formValues.yearOfSelection}
                              onChange={handleInput}
                              id="yearOfSelection"
                              name="yearOfSelection"
                              maxLength={4}
                              inputMode="numeric"
                              pattern="\d{4}"
                              readOnly={readOnly}
                              required={formValues.selectedByApps === 'Yes'} // Required if "Yes"
                            // onInput={(e) => {
                            //   e.target.value = e.target.value.replace(/[^0-9]/g, '').slice(0, 4);
                            // }}
                            />
                          </div>
                          <div className="col-md-6">
                            <label htmlFor="selectionserialnumber" className="form-label">
                              Serial Number of selection
                              {/* <span className="text-danger">*</span> */}
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={formValues.snoOfSelection}
                              onChange={handleInput}
                              id="snoOfSelection"
                              name="snoOfSelection"
                              maxLength={8}
                              readOnly={readOnly}
                              required={formValues.selectedByApps === 'Yes'} // Required if "Yes"
                            />
                          </div>
                        </div>
                      )}

                      {/* Fields to show when "No" is selected */}
                      {formValues.selectedByApps === 'No' && (
                        <div className="row">
                          <div className="col-md-6">
                            <label htmlFor="notUnderAppscPreview" className="form-label">
                              If the post is not under purview of APPSC/TGPSC, the mode of recruitment is to be specified
                              {/* <span className="text-danger">*</span> */}
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={formValues.notUnderAppscPreview}
                              onChange={handleInput}
                              id="notUnderAppscPreview"
                              name="notUnderAppscPreview"
                              readOnly={readOnly}
                              required={formValues.selectedByApps === 'No'} // Required if "No"
                            />
                          </div>

                          <div className="col-md-6">
                            <label htmlFor="yearOfJoining" className="form-label" style={{ marginBottom: '20px' }}>
                              Year of Appointment
                            </label>
                            <input
                              type="date"
                              className="form-control"
                              value={formValues.yearOfJoining ? formValues.yearOfJoining.split('T')[0] : ''}
                              onChange={handleInput}
                              id="yearOfJoining"
                              name="yearOfJoining"
                              readOnly={readOnly}
                              required={formValues.selectedByApps === 'No'} // Required if "No"
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* <div className="col-md-12">
                    <label className="form-label">Whether he/she services are regularized or probation declared?</label>
                    <div>
                      <label className="radio-inline">
                        <input type="radio" id="yes" name="serviceStatus" value="yes"
                          onChange={handleInput} checked={formValues.serviceStatus === 'yes'} /> Yes
                      </label>
                      <label className="radio-inline ml-3">
                        <input type="radio" id="no" name="serviceStatus" value="no"
                          onChange={handleInput} checked={formValues.serviceStatus === 'no'} /> No
                      </label>
                    </div>
                  </div> */}

                  {
                    !sessionStorage.getItem('userRole') && (
                      <div className="col-md-12">
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <label className="form-label" style={{ marginBottom: 0 }}>
                            Whether he/she services are regularized or probation declared?
                          </label>
                          <div style={{ display: 'flex' }}>
                            <label style={{ marginRight: '15px' }}>
                              <input
                                type="radio"
                                id="yes"
                                name="serviceStatus"
                                value="yes"
                                onChange={handleInput}
                                checked={formValues.serviceStatus === 'yes'}
                              />
                              <label htmlFor="employmentVoucherYes" className="form-label ms-0.9"> Yes</label>
                            </label>
                            <label>
                              <input
                                type="radio"
                                id="no"
                                name="serviceStatus"
                                value="no"
                                onChange={handleInput}
                                checked={formValues.serviceStatus === 'no'}
                              />
                              <label htmlFor="employmentVoucherYes" className="form-label ms-0.9"> No</label>
                            </label>
                          </div>
                        </div>
                      </div>
                    )
                  }


                  <div className="col-md-12">


                    <label for="selectionserialnumber" className="form-label">if services are regularized or probation
                      declared, a copy of order in which the services are regularized on probation declared is to be enclosed  (
                      upload the file in the relevant section
                      )</label>
                    {/* <input type="text" className="form-control" value={formValues.probationDeclare} onChange={handleInput} id="probationDeclare" name="probationDeclare" readOnly={readOnly} /> */}

                  </div>


                  {/* <div className="col-md-12">
                    <div className="container-fluid p-0">
                      <div className="row">
                        <div className="col-md-10">
                          <label for="selectionserialnumber" className="form-label">Whether he/she is proceeding on employment voucher.</label>
                        </div>
                        <div className="col-md-2" style={{ "text-align": "right" }}>
                          <div className="switchButtonWrapper" onClick={() => toggleSwitch('switchButton2', 'switchStatus2', 'switchRemarks2', 'employmentVoucher')}>
                            <button id="switchButton2" className={formValues.employmentVoucher == 'Yes' ? 'switchButton active' : 'switchButton'}></button>
                            <span id="switchStatus2">{formValues.employmentVoucher ?? 'No'}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div id='switchRemarks2' className={formValues.employmentVoucher == 'Yes' ? '' : 'd-none'}>
                      <label for="selectionserialnumber" className="form-label">If so, give details <span className="text-danger">*</span></label>
                      <textarea className="form-control" onChange={handleInput} value={formValues.employmentVoucherRemarks} id="employmentVoucherRemarks" name="employmentVoucherRemarks"
                        placeholder="write here" readOnly={readOnly}></textarea>
                    </div>
                  </div> */}

                  <div className="col-md-12">
                    <div className="container-fluid p-0">
                      <div className="row">
                        <div className="col-md-10">
                          <label htmlFor="selectionserialnumber" className="form-label">
                            Whether he/she is proceeding on employment voucher?
                          </label>
                        </div>
                        <div className="col-md-2" style={{ textAlign: 'right' }}>
                          <div className="radioButtonWrapper d-flex align-items-center">
                            <div className="me-3">
                              <input
                                type="radio"
                                id="employmentVoucherYes"
                                name="employmentVoucher"
                                value="Yes"
                                checked={formValues.employmentVoucher === 'Yes'}
                                onChange={handleInput}
                                disabled={readOnly}
                              />
                              <label htmlFor="employmentVoucherYes" className="form-label ms-0.9"> Yes</label>
                            </div>
                            <div>
                              <input
                                type="radio"
                                id="employmentVoucherNo"
                                name="employmentVoucher"
                                value="No"
                                checked={formValues.employmentVoucher === 'No'}
                                onChange={handleInput}
                                disabled={readOnly}
                              />
                              <label htmlFor="employmentVoucherNo" className="form-label ms-0.9"> No</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Display the text area only if "No" is selected */}
                    <div id="switchRemarks2">
                      <label htmlFor="selectionserialnumber" className="form-label">
                        If so, give details <span className="text-danger">*</span>
                      </label>
                      <textarea
                        className="form-control"
                        onChange={handleInput}
                        value={formValues.employmentVoucherRemarks}
                        id="employmentVoucherRemarks"
                        name="employmentVoucherRemarks"
                        placeholder="write here"
                        readOnly={readOnly}
                      />
                    </div>
                  </div>





                  <div className="col-md-12">
                    <div className="container-fluid p-0">
                      <div className="row">
                        <div className="col-md-9">
                          <label htmlFor="workUnderGovPriv" className="form-label">
                            Whether the employment in which he/she wants to work under government or private institution?
                          </label>
                        </div>
                        <div className="col-md-3" style={{ textAlign: 'right' }}>
                          <div className="radioButtonWrapper">
                            {/* Horizontal Radio Buttons */}
                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                id="workUnderGovPrivYes"
                                name="workUnderGovPriv"
                                value="Yes"
                                checked={formValues.workUnderGovPriv === 'Yes'}
                                onChange={handleInput}
                                disabled={readOnly}
                              />
                              <label htmlFor="workUnderGovPrivYes" className="form-label ms-0.9"> Yes</label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                id="workUnderGovPrivNo"
                                name="workUnderGovPriv"
                                value="No"
                                checked={formValues.workUnderGovPriv === 'No'}
                                onChange={handleInput}
                                disabled={readOnly}
                              />
                              <label htmlFor="workUnderGovPrivNo" className="form-label ms-0.9">No</label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                id="workUnderGovPrivNo"
                                name="workUnderGovPriv"
                                value="NA"
                                checked={formValues.workUnderGovPriv === 'NA'}
                                onChange={handleInput}
                                disabled={readOnly}
                              />
                              <label htmlFor="workUnderGovPrivNA" className="form-label ms-0.9">NA</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Remarks Section - Always Visible for both Yes and No */}
                    <div id="switchRemarks3">
                      <label htmlFor="workUnderGovPrivRemarks" className="form-label">
                        If so, the appointment order of the institution to be enclosed <span className="text-danger">*</span>
                      </label>
                      <textarea
                        className="form-control"
                        value={formValues.workUnderGovPrivRemarks}
                        onChange={handleInput}
                        id="workUnderGovPrivRemarks"
                        name="workUnderGovPrivRemarks"
                        placeholder={
                          formValues.workUnderGovPriv === 'Yes'
                            ? 'Enter the appointment order of the institution'
                            : 'Enter remarks for not opting for government or private institution employment'
                        }
                        readOnly={readOnly}
                      />
                    </div>
                  </div>


                  {/* <div className="col-md-12">
                    <div className="container-fluid p-0">
                      <div className="row">
                        <div className="col-md-10">
                          <label for="selectionserialnumber" className="form-label">Whether the employment in which he/she wants to work under government or private institution.</label>
                        </div>
                        <div className="col-md-2" style={{ "text-align": "right" }}>
                          <div className="switchButtonWrapper" onClick={() => toggleSwitch('switchButton3', 'switchStatus3', 'switchRemarks3', 'workUnderGovPriv')}>
                            <button id="switchButton3" className={formValues.workUnderGovPriv == 'Yes' ? 'switchButton active' : 'switchButton'}></button>
                            <span id="switchStatus3">{formValues.workUnderGovPriv ?? 'No'}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div id='switchRemarks3' className={formValues.workUnderGovPriv == 'Yes' ? '' : 'd-none'}>
                      <label for="selectionserialnumber" className="form-label">If so, the appointment order of the institution to be
                        enclosed <span className="text-danger">*</span></label>
                      <textarea className="form-control" value={formValues.workUnderGovPrivRemarks} onChange={handleInput} id="workUnderGovPrivRemarks" name="workUnderGovPrivRemarks"
                        placeholder="write here" readOnly={readOnly}></textarea>
                    </div>
                  </div> */}

                  {/* ok latest change */}

                  {/* <div className="col-md-12">
                    <div className="container-fluid p-0">
                      <div className="row">
                        <div className="col-md-10">
                          <label for="selectionserialnumber" className="form-label">Whether he/she is willing to pay pension contribution & terminal gratuity for the period of employment during EOL since a govt servant cannot however claim service benefits from two sources in respect of the same service.</label>
                        </div>
                        <div className="col-md-2" style={{ "text-align": "right" }}>
                          <div className="switchButtonWrapper" onClick={() => toggleSwitch('switchButton4', 'switchStatus4', 'switchRemarks4', 'pensionTerminalGratuity')}>
                            <button id="switchButton4" className={formValues.pensionTerminalGratuity == 'Yes' ? 'switchButton active' : 'switchButton'}></button>
                            <span id="switchStatus4">{formValues.pensionTerminalGratuity ?? 'No'}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div id='switchRemarks4' className={formValues.pensionTerminalGratuity == 'Yes' ? '' : 'd-none'}>
                      <label for="selectionserialnumber" className="form-label">If so, give details<span className="text-danger">*</span></label>
                      <textarea className="form-control" value={formValues.pensionTerminalGratuityRemarks} onChange={handleInput} id="pensionTerminalGratuityRemarks" name="pensionTerminalGratuityRemarks"
                        placeholder="write here" readOnly={readOnly}></textarea>
                    </div>
                  </div> */}

                  <div className="col-md-12">
                    <div className="container-fluid p-0">
                      <div className="row">
                        <div className="col-md-9">
                          <label htmlFor="pensionTerminalGratuity" className="form-label">
                            Whether he/she is willing to pay pension contribution & terminal gratuity for the period of employment during EOL since a govt servant cannot, however, claim service benefits from two sources in respect of the same service?
                          </label>
                        </div>
                        <div className="col-md-3" style={{ textAlign: 'right' }}>
                          <div className="radioButtonWrapper">
                            {/* Horizontal Radio Buttons */}
                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                id="pensionTerminalGratuityYes"
                                name="pensionTerminalGratuity"
                                value="Yes"
                                checked={formValues.pensionTerminalGratuity === 'Yes'}
                                onChange={handleInput}
                                disabled={readOnly}
                              />
                              <label htmlFor="pensionTerminalGratuityYes" className="form-label ms-0.9">Yes</label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                id="pensionTerminalGratuityNo"
                                name="pensionTerminalGratuity"
                                value="No"
                                checked={formValues.pensionTerminalGratuity === 'No'}
                                onChange={handleInput}
                                disabled={readOnly}
                              />
                              <label htmlFor="pensionTerminalGratuityNo" className="form-label ms-0.9">No</label>
                            </div>

                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                id="pensionTerminalGratuityNo"
                                name="pensionTerminalGratuity"
                                value="NA"
                                checked={formValues.pensionTerminalGratuity === 'NA'}
                                onChange={handleInput}
                                disabled={readOnly}
                              />
                              <label htmlFor="pensionTerminalGratuityNA" className="form-label ms-0.9">NA</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Remarks Section - Always Visible for both Yes and No */}
                    <div id="switchRemarks4">
                      <label htmlFor="pensionTerminalGratuityRemarks" className="form-label">
                        If so, give details <span className="text-danger">*</span>
                      </label>
                      <textarea
                        className="form-control"
                        value={formValues.pensionTerminalGratuityRemarks}
                        onChange={handleInput}
                        id="pensionTerminalGratuityRemarks"
                        name="pensionTerminalGratuityRemarks"
                        placeholder="Write here"
                        readOnly={readOnly}
                      />
                    </div>
                  </div>







                  {/* <div className="col-md-12">
                    <div className="container-fluid p-0">
                      <div className="row">
                        <div className="col-md-10">
                          <label for="selectionserialnumber" className="form-label">Whether he/she has taken any leave earlier for
                            pursuing higher studies abroad such as post-graduation course or diploma course of in India.</label>
                        </div>
                        <div className="col-md-2" style={{ "text-align": "right" }}>
                          <div className="switchButtonWrapper" onClick={() => toggleSwitch('switchButton5', 'switchStatus5', 'switchRemarks5', 'earlyLeave')}>
                            <button id="switchButton5" className={formValues.earlyLeave == 'Yes' ? 'switchButton active' : 'switchButton'}></button>
                            <span id="switchStatus5">{formValues.earlyLeave ?? 'No'}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div id='switchRemarks5' className={formValues.earlyLeave == 'Yes' ? '' : 'd-none'}>
                      <label for="selectionserialnumber" className="form-label">If so, give details<span className="text-danger">*</span></label>
                      <textarea className="form-control" value={formValues.earlyLeaveRemarks} onChange={handleInput} id="earlyLeaveRemarks" name="earlyLeaveRemarks"
                        placeholder="write here" readOnly={readOnly}></textarea>
                    </div>
                  </div> */}

                  <div className="col-md-12">
                    <div className="container-fluid p-0">
                      <div className="row">
                        <div className="col-md-10">
                          <label htmlFor="earlyLeave" className="form-label">
                            Whether he/she has taken any leave earlier for pursuing higher studies abroad such as post-graduation course or diploma course in India?
                          </label>
                        </div>
                        <div className="col-md-2" style={{ textAlign: 'right' }}>
                          <div className="radioButtonWrapper">
                            {/* Horizontal Radio Buttons */}
                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                id="earlyLeaveYes"
                                name="earlyLeave"
                                value="Yes"
                                checked={formValues.earlyLeave === 'Yes'}
                                onChange={handleInput}
                                disabled={readOnly}
                              />
                              <label htmlFor="earlyLeaveYes" className="form-label ms-0.9">Yes</label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                id="earlyLeaveNo"
                                name="earlyLeave"
                                value="No"
                                checked={formValues.earlyLeave === 'No'}
                                onChange={handleInput}
                                disabled={readOnly}
                              />
                              <label htmlFor="earlyLeaveNo" className="form-label ms-0.9">No</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Remarks Section - Always Visible for both Yes and No */}
                    <div id="switchRemarks5">
                      <label htmlFor="earlyLeaveRemarks" className="form-label">
                        If so, give details <span className="text-danger">*</span>
                      </label>
                      <textarea
                        className="form-control"
                        value={formValues.earlyLeaveRemarks}
                        onChange={handleInput}
                        id="earlyLeaveRemarks"
                        name="earlyLeaveRemarks"
                        placeholder="Write here"
                        readOnly={readOnly}
                      />
                    </div>
                  </div>




                  {/* <div className="col-md-12">
                    <div className="container-fluid p-0">
                      <div className="row">
                        <div className="col-md-10">
                          <label for="selectionserialnumber" className="form-label">The period of availment of leave with date is to
                            be stated. <span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-2" style={{ "text-align": "right" }}>
                          <div className="switchButtonWrapper" onClick={() => toggleSwitch('switchButton6', 'switchStatus6', 'switchRemarks6', 'periodOfAvailment')}>
                            <button id="switchButton6" className={formValues.periodOfAvailment == 'Yes' ? 'switchButton active' : 'switchButton'}></button>
                            <span id="switchStatus6">{formValues.periodOfAvailment ?? 'No'}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div id='switchRemarks6' className={formValues.periodOfAvailment == 'Yes' ? '' : 'd-none'}>
                      <textarea className="form-control" value={formValues.periodOfAvailmentRemarks} onChange={handleInput} id="periodOfAvailmentRemarks" name="periodOfAvailmentRemarks"
                        placeholder="write here" readOnly={readOnly}></textarea>
                    </div>
                  </div> */}

                  <div className="col-md-12">
                    <div className="container-fluid p-0">
                      <div className="row">
                        <div className="col-md-9">
                          <label htmlFor="periodOfAvailment" className="form-label">
                            The period of availment of leave with date is to be stated. <span className="text-danger">*</span>
                          </label>
                        </div>
                        <div className="col-md-3" style={{ textAlign: 'right' }}>
                          <div className="radioButtonWrapper">
                            {/* Horizontal Radio Buttons */}
                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                id="periodOfAvailmentYes"
                                name="periodOfAvailment"
                                value="Yes"
                                checked={formValues.periodOfAvailment === 'Yes'}
                                onChange={handleInput}
                                disabled={readOnly}
                              />
                              <label htmlFor="periodOfAvailmentYes" className="form-label ms-0.9">Yes</label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                id="periodOfAvailmentNo"
                                name="periodOfAvailment"
                                value="No"
                                checked={formValues.periodOfAvailment === 'No'}
                                onChange={handleInput}
                                disabled={readOnly}
                              />
                              <label htmlFor="periodOfAvailmentNo" className="form-label ms-0.9">No</label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                id="periodOfAvailmentNo"
                                name="periodOfAvailment"
                                value="NA"
                                checked={formValues.periodOfAvailment === 'NA'}
                                onChange={handleInput}
                                disabled={readOnly}
                              />
                              <label htmlFor="periodOfAvailmentNA" className="form-label ms-0.9">NA</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Remarks Section - Always Visible for both Yes and No */}
                    <div id="switchRemarks6">
                      <label htmlFor="periodOfAvailmentRemarks" className="form-label">
                        If so, give details <span className="text-danger">*</span>
                      </label>
                      <textarea
                        className="form-control"
                        value={formValues.periodOfAvailmentRemarks}
                        onChange={handleInput}
                        id="periodOfAvailmentRemarks"
                        name="periodOfAvailmentRemarks"
                        placeholder="Write here"
                        readOnly={readOnly}
                      />
                    </div>
                  </div>




                  {/* <div className="col-md-12">
                    <div className="container-fluid p-0">
                      <div className="row">
                        <div className="col-md-10">
                          <label for="selectionserialnumber" className="form-label">The condition of the Bond so executed for the
                            above purpose to be stated<span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-2" style={{ "text-align": "right" }}>
                          <div className="switchButtonWrapper" onClick={() => toggleSwitch('switchButton7', 'switchStatus7', 'switchRemarks7', 'conditionOfBond')}>
                            <button id="switchButton7" className={formValues.conditionOfBond == 'Yes' ? 'switchButton active' : 'switchButton'}></button>
                            <span id="switchStatus7">{formValues.conditionOfBond ?? 'No'}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div id='switchRemarks7' className={formValues.conditionOfBond == 'Yes' ? '' : 'd-none'}>
                      <textarea className="form-control" value={formValues.conditionOfBondRemarks} onChange={handleInput} id="conditionOfBondRemarks" name="conditionOfBondRemarks"
                        placeholder="write here" readOnly={readOnly} ></textarea>
                    </div>
                  </div> */}

                  <div className="col-md-12">
                    <div className="container-fluid p-0">
                      <div className="row">
                        <div className="col-md-10">
                          <label htmlFor="conditionOfBond" className="form-label">
                            The condition of the Bond so executed for the above purpose to be stated <span className="text-danger">*</span>
                          </label>
                        </div>
                        <div className="col-md-2" style={{ textAlign: 'right' }}>
                          <div className="radioButtonWrapper">
                            {/* Horizontal Radio Buttons */}
                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                id="conditionOfBondYes"
                                name="conditionOfBond"
                                value="Yes"
                                checked={formValues.conditionOfBond === 'Yes'}
                                onChange={handleInput}
                                disabled={readOnly}
                              />
                              <label htmlFor="conditionOfBondYes" className="form-label ms-0.9">Yes</label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                id="conditionOfBondNo"
                                name="conditionOfBond"
                                value="No"
                                checked={formValues.conditionOfBond === 'No'}
                                onChange={handleInput}
                                disabled={readOnly}
                              />
                              <label htmlFor="conditionOfBondNo" className="form-label ms-0.9">No</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Remarks Section - Always Visible for both Yes and No */}
                    <div id="switchRemarks7">
                      <label htmlFor="conditionOfBondRemarks" className="form-label">
                        If so, give details <span className="text-danger">*</span>
                      </label>
                      <textarea
                        className="form-control"
                        value={formValues.conditionOfBondRemarks}
                        onChange={handleInput}
                        id="conditionOfBondRemarks"
                        name="conditionOfBondRemarks"
                        placeholder="Write here"
                        readOnly={readOnly}
                      />
                    </div>
                  </div>


                  {/* <div className="col-md-12">
                    <div className="container-fluid p-0">
                      <div className="row">
                        <div className="col-md-10">
                          <label for="selectionserialnumber" className="form-label">Whether the leave taken earlier has been
                            regularized.</label>
                        </div>
                        <div className="col-md-2" style={{ "text-align": "right" }}>
                          <div className="switchButtonWrapper" onClick={() => toggleSwitch('switchButton8', 'switchStatus8', 'switchRemarks8', 'regularisedEarlyLeave')}>
                            <button id="switchButton8" className={formValues.regularisedEarlyLeave == 'Yes' ? 'switchButton active' : 'switchButton'}></button>
                            <span id="switchStatus8">{formValues.regularisedEarlyLeave ?? 'No'}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div id='switchRemarks8' className={formValues.regularisedEarlyLeave == 'Yes' ? '' : 'd-none'}>
                      <label for="selectionserialnumber" className="form-label">if so, a copy of the order is furnished <span className="text-danger">*</span></label>
                      <textarea className="form-control" value={formValues.regularisedEarlyLeaveRemarks} onChange={handleInput} id="regularisedEarlyLeaveRemarks" name="regularisedEarlyLeaveRemarks"
                        placeholder="write here" readOnly={readOnly}></textarea>
                    </div>
                  </div> */}

                  <div className="col-md-12">
                    <div className="container-fluid p-0">
                      <div className="row">
                        <div className="col-md-9">
                          <label htmlFor="regularisedEarlyLeave" className="form-label">
                            Whether the leave taken earlier has been regularized?
                          </label>
                        </div>
                        <div className="col-md-3" style={{ textAlign: 'right' }}>
                          <div className="radioButtonWrapper">
                            {/* Horizontal Radio Buttons */}
                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                id="regularisedEarlyLeaveYes"
                                name="regularisedEarlyLeave"
                                value="Yes"
                                checked={formValues.regularisedEarlyLeave === 'Yes'}
                                onChange={handleInput}
                                disabled={readOnly}
                              />
                              <label htmlFor="regularisedEarlyLeaveYes" className="form-label ms-0.9">Yes</label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                id="regularisedEarlyLeaveNo"
                                name="regularisedEarlyLeave"
                                value="No"
                                checked={formValues.regularisedEarlyLeave === 'No'}
                                onChange={handleInput}
                                disabled={readOnly}
                              />
                              <label htmlFor="regularisedEarlyLeaveNo" className="form-label ms-0.9">No</label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                id="regularisedEarlyLeaveNo"
                                name="regularisedEarlyLeave"
                                value="NA"
                                checked={formValues.regularisedEarlyLeave === 'NA'}
                                onChange={handleInput}
                                disabled={readOnly}
                              />
                              <label htmlFor="regularisedEarlyLeaveNA" className="form-label ms-0.9">NA</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Remarks Section - Always Visible for both Yes and No */}
                    <div id="switchRemarks8">
                      <label htmlFor="regularisedEarlyLeaveRemarks" className="form-label">
                        If so, a copy of the order is furnished <span className="text-danger">*</span>
                      </label>
                      <textarea
                        className="form-control"
                        value={formValues.regularisedEarlyLeaveRemarks}
                        onChange={handleInput}
                        id="regularisedEarlyLeaveRemarks"
                        name="regularisedEarlyLeaveRemarks"
                        placeholder="Write here"
                        readOnly={readOnly}
                      />
                    </div>
                  </div>



                  <div className="col-md-12">
                    <div className="container-fluid p-0">
                      <div className="row">
                        <div className="col-md-9">
                          <label for="selectionserialnumber" className="form-label">The date of rejoining duty after expiry of the above leave period.</label>
                        </div>
                        <div className="col-md-3">
                          <input type="date" className="form-control" value={formValues.dateOfRejoin ? formValues.dateOfRejoin.split('T')[0] : ''} onChange={handleInput} id="dateOfRejoin" name="dateOfRejoin" placeholder="write here" min={currentDateRej} readOnly={readOnly}></input>
                        </div>
                      </div>
                    </div>
                  </div>



                  {/* <div className="col-md-12">
                    <div className="container-fluid p-0">
                      <div className="row">
                        <div className="col-md-10">
                          <label for="selectionserialnumber" className="form-label">Whether he/she has fulfilled the conditions of the bond so executed.<span className="text-danger">*</span> </label>
                        </div>
                        <div className="col-md-2" style={{ "text-align": "right" }}>
                          <div className="switchButtonWrapper" onClick={() => toggleSwitch('switchButton9', 'switchStatus9', 'switchRemarks9', 'fulfillConditionOfBond')}>
                            <button id="switchButton9" className={formValues.fulfillConditionOfBond == 'Yes' ? 'switchButton active' : 'switchButton'}></button>
                            <span id="switchStatus9">{formValues.fulfillConditionOfBond ?? 'No'}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div id='switchRemarks9' className={formValues.fulfillConditionOfBond == 'Yes' ? '' : 'd-none'}>
                      <label for="selectionserialnumber" className="form-label">if so, details<span className="text-danger">*</span></label>
                      <textarea className="form-control" value={formValues.fulfillConditionOfBondRemarks} onChange={handleInput} id="fulfillConditionOfBondRemarks" name="fulfillConditionOfBondRemarks"
                        placeholder="write here" readOnly={readOnly}></textarea>
                    </div>
                  </div> */}

                  <div className="col-md-12">
                    <div className="container-fluid p-0">
                      <div className="row">
                        <div className="col-md-10">
                          <label htmlFor="fulfillConditionOfBond" className="form-label">
                            Whether he/she has fulfilled the conditions of the bond so executed? <span className="text-danger">*</span>
                          </label>
                        </div>
                        <div className="col-md-2" style={{ textAlign: 'right' }}>
                          <div className="radioButtonWrapper">
                            {/* Horizontal Radio Buttons */}
                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                id="fulfillConditionOfBondYes"
                                name="fulfillConditionOfBond"
                                value="Yes"
                                checked={formValues.fulfillConditionOfBond === 'Yes'}
                                onChange={handleInput}
                                disabled={readOnly}
                              />
                              <label htmlFor="fulfillConditionOfBondYes" className="form-label ms-0.9">Yes</label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                id="fulfillConditionOfBondNo"
                                name="fulfillConditionOfBond"
                                value="No"
                                checked={formValues.fulfillConditionOfBond === 'No'}
                                onChange={handleInput}
                                disabled={readOnly}
                              />
                              <label htmlFor="fulfillConditionOfBondNo" className="form-label ms-0.9">No</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Remarks Section - Always Visible for both Yes and No */}
                    <div id="switchRemarks9">
                      <label htmlFor="fulfillConditionOfBondRemarks" className="form-label">
                        If so, details <span className="text-danger">*</span>
                      </label>
                      <textarea
                        className="form-control"
                        value={formValues.fulfillConditionOfBondRemarks}
                        onChange={handleInput}
                        id="fulfillConditionOfBondRemarks"
                        name="fulfillConditionOfBondRemarks"
                        placeholder="Write here"
                        readOnly={readOnly}
                      />
                    </div>
                  </div>


                  {/* <div className="col-md-12">
                    <div className="container-fluid p-0">
                      <div className="row">
                        <div className="col-md-10">
                          <label for="selectionserialnumber" className="form-label">Whether he/she is willing to proceed abroad on
                            EOL.</label>
                        </div>
                        <div className="col-md-2" style={{ "text-align": "right" }}>
                          <div className="switchButtonWrapper" onClick={() => toggleSwitch('switchButton10', 'switchStatus10', 'switchRemarks10', 'eol')}>
                            <button id="switchButton10" className={formValues.eol == 'Yes' ? 'switchButton active' : 'switchButton'}></button>
                            <span id="switchStatus10">{formValues.eol ?? 'No'}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div id='switchRemarks10' className={formValues.eol == 'Yes' ? '' : 'd-none'}>
                      <label for="selectionserialnumber" className="form-label">if so, details<span className="text-danger">*</span></label>
                      <textarea className="form-control" value={formValues.eolRemarks} onChange={handleInput} id="eolRemarks" name="eolRemarks"
                        placeholder="write here" readOnly={readOnly}></textarea>
                    </div>
                  </div> */}

                  <div className="col-md-12">
                    <div className="container-fluid p-0">
                      <div className="row">
                        <div className="col-md-9">
                          <label htmlFor="eol" className="form-label">
                            Whether he/she is willing to proceed abroad on EOL?
                          </label>
                        </div>
                        <div className="col-md-3" style={{ textAlign: 'right' }}>
                          <div className="radioButtonWrapper">
                            {/* Horizontal Radio Buttons */}
                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                id="eolYes"
                                name="eol"
                                value="Yes"
                                checked={formValues.eol === 'Yes'}
                                onChange={handleInput}
                                disabled={readOnly}
                              />
                              <label htmlFor="eolYes" className="form-label ms-0.9">Yes</label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                id="eolNo"
                                name="eol"
                                value="No"
                                checked={formValues.eol === 'No'}
                                onChange={handleInput}
                                disabled={readOnly}
                              />
                              <label htmlFor="eolNo" className="form-label ms-0.9">No</label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                id="eolNo"
                                name="eol"
                                value="NA"
                                checked={formValues.eol === 'NA'}
                                onChange={handleInput}
                                disabled={readOnly}
                              />
                              <label htmlFor="eolNA" className="form-label ms-0.9">NA</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Remarks Section - Always Visible for both Yes and No */}
                    <div id="switchRemarks10">
                      <label htmlFor="eolRemarks" className="form-label">
                        If so, details <span className="text-danger">*</span>
                      </label>
                      <textarea
                        className="form-control"
                        value={formValues.eolRemarks}
                        onChange={handleInput}
                        id="eolRemarks"
                        name="eolRemarks"
                        placeholder="Write here"
                        readOnly={readOnly}
                      />
                    </div>
                  </div>




                  {/* <div className="col-md-12">
                    <div className="container-fluid p-0">
                      <div className="row">
                        <div className="col-md-10">
                          <label for="selectionserialnumber" className="form-label">Whether he/she is willing to execute a bond to the effect that he/she will serve the govt for three years on return from abroad and in default, to pay Rs 10,000 to the institute.</label>
                        </div>
                        <div className="col-md-2" style={{ "text-align": "right" }}>
                          <div className="switchButtonWrapper" onClick={() => toggleSwitch('switchButton11', 'switchStatus11', 'switchRemarks11', 'executionOfBond')}>
                            <button id="switchButton11" className={formValues.executionOfBond == 'Yes' ? 'switchButton active' : 'switchButton'}></button>
                            <span id="switchStatus11">{formValues.executionOfBond ?? 'No'}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div id='switchRemarks11' className={formValues.selectedByApps == 'Yes' ? '' : 'd-none'}>
                      <label for="selectionserialnumber" className="form-label">if so, details<span className="text-danger">*</span></label>
                      <textarea className="form-control" value={formValues.executionOfBondRemarks} onChange={handleInput} id="executionOfBondRemarks" name="executionOfBondRemarks"
                        placeholder="write here" readOnly={readOnly}></textarea>
                    </div>
                  </div> */}


                  <div className="col-md-12">
                    <div className="container-fluid p-0">
                      <div className="row">
                        <div className="col-md-10">
                          <label htmlFor="executionOfBond" className="form-label">
                            Whether he/she is willing to execute a bond to the effect that he/she will serve the govt for three years on return from abroad and in default, to pay Rs 10,000 to the institute?
                          </label>
                        </div>
                        <div className="col-md-2" style={{ textAlign: 'right' }}>
                          <div className="radioButtonWrapper">
                            {/* Horizontal Radio Buttons */}
                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                id="executionOfBondYes"
                                name="executionOfBond"
                                value="Yes"
                                checked={formValues.executionOfBond === 'Yes'}
                                onChange={handleInput}
                                disabled={readOnly}
                              />
                              <label htmlFor="executionOfBondYes" className="form-label ms-0.9">Yes</label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                id="executionOfBondNo"
                                name="executionOfBond"
                                value="No"
                                checked={formValues.executionOfBond === 'No'}
                                onChange={handleInput}
                                disabled={readOnly}
                              />
                              <label htmlFor="executionOfBondNo" className="form-label ms-0.9">No</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Remarks Section - Always Visible for both Yes and No */}
                    <div id="switchRemarks11">
                      <label htmlFor="executionOfBondRemarks" className="form-label">
                        If so, details <span className="text-danger">*</span>
                      </label>
                      <textarea
                        className="form-control"
                        value={formValues.executionOfBondRemarks}
                        onChange={handleInput}
                        id="executionOfBondRemarks"
                        name="executionOfBondRemarks"
                        placeholder="Write here"
                        readOnly={readOnly}
                      />
                    </div>
                  </div>





                  {/* <div className="col-md-12">
                    <div className="container-fluid p-0">
                      <div className="row">
                        <div className="col-md-10">
                          <label for="selectionserialnumber" className="form-label">Whether any charges/dues are pending against him/her (certificate from Head of the Institute to be enclosed).</label>
                        </div>
                        <div className="col-md-2" style={{ "text-align": "right" }}>
                          <div className="switchButtonWrapper" onClick={() => toggleSwitch('switchButton12', 'switchStatus12', 'switchRemarks12', 'pendingCharges')}>
                            <button id="switchButton12" className={formValues.pendingCharges == 'Yes' ? 'switchButton active' : 'switchButton'}></button>
                            <span id="switchStatus12">{formValues.pendingCharges ?? 'No'}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div id='switchRemarks12' className={formValues.pendingCharges == 'Yes' ? '' : 'd-none'}>
                      <label for="selectionserialnumber" className="form-label">if so, details<span className="text-danger">*</span></label>
                      <textarea className="form-control" onChange={handleInput} value={formValues.pendingChargesRemarks} id="pendingChargesRemarks" name="pendingChargesRemarks"
                        placeholder="write here" readOnly={readOnly}></textarea>
                    </div>
                  </div> */}

                  <div className="col-md-12">
                    <div className="container-fluid p-0">
                      <div className="row">
                        <div className="col-md-10">
                          <label htmlFor="pendingCharges" className="form-label">
                            Whether any charges/dues are pending against him/her (certificate from Head of the Institute to be enclosed) ?
                          </label>
                        </div>
                        <div className="col-md-2" style={{ textAlign: 'right' }}>
                          <div className="radioButtonWrapper">
                            {/* Horizontal Radio Buttons */}
                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                id="pendingChargesYes"
                                name="pendingCharges"
                                value="Yes"
                                checked={formValues.pendingCharges === 'Yes'}
                                onChange={handleInput}
                                disabled={readOnly}
                              />
                              <label htmlFor="pendingChargesYes" className="form-label ms-0.9">Yes</label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                id="pendingChargesNo"
                                name="pendingCharges"
                                value="No"
                                checked={formValues.pendingCharges === 'No'}
                                onChange={handleInput}
                                disabled={readOnly}
                              />
                              <label htmlFor="pendingChargesNo" className="form-label ms-0.9">No</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Remarks Section - Always Visible for both Yes and No */}
                    <div id="switchRemarks12">
                      <label htmlFor="pendingChargesRemarks" className="form-label">
                        If so, details <span className="text-danger">*</span>
                      </label>
                      <textarea
                        className="form-control"
                        value={formValues.pendingChargesRemarks}
                        onChange={handleInput}
                        id="pendingChargesRemarks"
                        name="pendingChargesRemarks"
                        placeholder="Write here"
                        readOnly={readOnly}
                      />
                    </div>
                  </div>




                  {/* <div className="col-md-12">
                    <div className="container-fluid p-0">
                      <div className="row">
                        <div className="col-md-10">
                          <label for="selectionserialnumber" className="form-label">Whether he/she has drawn any interest free educational loans.</label>
                        </div>
                        <div className="col-md-2" style={{ "text-align": "right" }}>
                          <div className="switchButtonWrapper" onClick={() => toggleSwitch('switchButton13', 'switchStatus13', 'switchRemarks13', 'drawnEducationalLoan')}>
                            <button id="switchButton13" className={formValues.drawnEducationalLoan == 'Yes' ? 'switchButton active' : 'switchButton'}></button>
                            <span id="switchStatus13">{formValues.drawnEducationalLoan ?? 'No'}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div id='switchRemarks13' className={formValues.drawnEducationalLoan == 'Yes' ? '' : 'd-none'}>
                      <label for="selectionserialnumber" className="form-label">If so, give details (Certificate from head of the Institute is to be enclosed)<span className="text-danger">*</span></label>
                      <textarea className="form-control" onChange={handleInput} value={formValues.drawnEducationalLoanRemarks} id="drawnEducationalLoanRemarks" name="drawnEducationalLoanRemarks"
                        placeholder="write here" readOnly={readOnly}></textarea>
                    </div>
                  </div> */}

                  <div className="col-md-12">
                    <div className="container-fluid p-0">
                      <div className="row">
                        <div className="col-md-10">
                          <label htmlFor="drawnEducationalLoan" className="form-label">
                            Whether he/she has drawn any interest-free educational loans?
                          </label>
                        </div>
                        <div className="col-md-2" style={{ textAlign: 'right' }}>
                          <div className="radioButtonWrapper">
                            {/* Horizontal Radio Buttons */}
                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                id="drawnEducationalLoanYes"
                                name="drawnEducationalLoan"
                                value="Yes"
                                checked={formValues.drawnEducationalLoan === 'Yes'}
                                onChange={handleInput}
                                disabled={readOnly}
                              />
                              <label htmlFor="drawnEducationalLoanYes" className="form-label ms-0.9">Yes</label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                id="drawnEducationalLoanNo"
                                name="drawnEducationalLoan"
                                value="No"
                                checked={formValues.drawnEducationalLoan === 'No'}
                                onChange={handleInput}
                                disabled={readOnly}
                              />
                              <label htmlFor="drawnEducationalLoanNo" className="form-label ms-0.9">No</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Remarks Section - Always Visible for both Yes and No */}
                    <div id="switchRemarks13">
                      <label htmlFor="drawnEducationalLoanRemarks" className="form-label">
                        If so, give details (Certificate from head of the Institute is to be enclosed)<span className="text-danger">*</span>
                      </label>
                      <textarea
                        className="form-control"
                        value={formValues.drawnEducationalLoanRemarks}
                        onChange={handleInput}
                        id="drawnEducationalLoanRemarks"
                        name="drawnEducationalLoanRemarks"
                        placeholder="Write here"
                        readOnly={readOnly}
                      />
                    </div>
                  </div>


                  <div className="col-md-12">
                    <label for="selectionserialnumber" className="form-label">Name of the Medical College in which he/she studied MBBS course, and the period of study is to be mentioned. In case studied MBBS course in more
                      than one medical College, Furnish the names of the colleges with year of the study of course </label>
                    <textarea className="form-control" onChange={handleInput} value={formValues.nameOfMedicalCollege} id="nameOfMedicalCollege" name="nameOfMedicalCollege"
                      placeholder="write here" readOnly={readOnly}></textarea>
                  </div>

                  {/* <div className="col-md-12">
                    <div className="container-fluid p-0">
                      <div className="row">
                        <div className="col-md-10">
                          <label for="selectionserialnumber" className="form-label">Whether the applicant has repaid the entire loan amount.</label>
                        </div>
                        <div className="col-md-2" style={{ "text-align": "right" }}>
                          <div className="switchButtonWrapper" onClick={() => toggleSwitch('switchButton14', 'switchStatus14', 'switchRemarks14', 'repaymentOfLoan')}>
                            <button id="switchButton14" className={formValues.repaymentOfLoan == 'Yes' ? 'switchButton active' : 'switchButton'}></button>
                            <span id="switchStatus14">{formValues.repaymentOfLoan ?? 'No'}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div id='switchRemarks14' className={formValues.repaymentOfLoan == 'Yes' ? '' : 'd-none'}>
                      <label for="selectionserialnumber" className="form-label">if any taken by him/her and if not, how much amount is still outstanding<span className="text-danger">*</span></label>
                      <textarea className="form-control" value={formValues.repaymentOfLoanRemarks} onChange={handleInput} id="repaymentOfLoanRemarks" name="repaymentOfLoanRemarks"
                        placeholder="write here" readOnly={readOnly}></textarea>
                    </div>
                  </div> */}

                  <div className="col-md-12">
                    <div className="container-fluid p-0">
                      <div className="row">
                        <div className="col-md-9">
                          <label htmlFor="repaymentOfLoan" className="form-label">
                            Whether the applicant has repaid the entire loan amount?
                          </label>
                        </div>
                        <div className="col-md-3" style={{ textAlign: 'right' }}>
                          <div className="radioButtonWrapper">
                            {/* Horizontal Radio Buttons */}
                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                id="repaymentOfLoanYes"
                                name="repaymentOfLoan"
                                value="Yes"
                                checked={formValues.repaymentOfLoan === 'Yes'}
                                onChange={handleInput}
                                disabled={readOnly}
                              />
                              <label htmlFor="repaymentOfLoanYes" className="form-label ms-0.9">Yes</label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                id="repaymentOfLoanNo"
                                name="repaymentOfLoan"
                                value="No"
                                checked={formValues.repaymentOfLoan === 'No'}
                                onChange={handleInput}
                                disabled={readOnly}
                              />
                              <label htmlFor="repaymentOfLoanNo" className="form-label ms-0.9">No</label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                id="repaymentOfLoanNo"
                                name="repaymentOfLoan"
                                value="NA"
                                checked={formValues.repaymentOfLoan === 'NA'}
                                onChange={handleInput}
                                disabled={readOnly}
                              />
                              <label htmlFor="repaymentOfLoanNA" className="form-label ms-0.9">NA</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Remarks Section - Always Visible for both Yes and No */}
                    <div id="switchRemarks14">
                      <label htmlFor="repaymentOfLoanRemarks" className="form-label">
                        If any taken by him/her and if not, how much amount is still outstanding<span className="text-danger">*</span>
                      </label>
                      <textarea
                        className="form-control"
                        value={formValues.repaymentOfLoanRemarks}
                        onChange={handleInput}
                        id="repaymentOfLoanRemarks"
                        name="repaymentOfLoanRemarks"
                        placeholder="Write here"
                        readOnly={readOnly}
                      />
                    </div>
                  </div>


                  {/* <div className="col-md-12">
                    <div className="container-fluid p-0">
                      <div className="row">
                        <div className="col-md-10">
                          <label for="selectionserialnumber" className="form-label">Whether he/she has drawn any kind of govt loans. If not, a certificate from Head of Institute is to be enclosed.</label>
                        </div>
                        <div className="col-md-2" style={{ "text-align": "right" }}>
                          <div className="switchButtonWrapper" onClick={() => toggleSwitch('switchButton15', 'switchStatus15', 'switchRemarks15', 'drawnOfGovernmentLoans')}>
                            <button id="switchButton15" className={formValues.drawnOfGovernmentLoans == 'Yes' ? 'switchButton active' : 'switchButton'}></button>
                            <span id="switchStatus15">{formValues.drawnOfGovernmentLoans ?? 'No'}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div id='switchRemarks15' className={formValues.drawnOfGovernmentLoans == 'Yes' ? '' : 'd-none'}>
                      <label for="selectionserialnumber" className="form-label">If so, furnish details. <span className="text-danger">*</span></label>
                      <textarea className="form-control" value={formValues.drawnOfGovernmentLoansRemarks} onChange={handleInput} id="drawnOfGovernmentLoansRemarks" name="drawnOfGovernmentLoansRemarks"
                        placeholder="write here" readOnly={readOnly}></textarea>
                    </div>
                  </div> */}

                  <div className="col-md-12">
                    <div className="container-fluid p-0">
                      <div className="row">
                        <div className="col-md-10">
                          <label htmlFor="drawnOfGovernmentLoans" className="form-label">
                            Whether he/she has drawn any kind of govt loans. If not, a certificate from Head of Institute is to be enclosed?
                          </label>
                        </div>
                        <div className="col-md-2" style={{ textAlign: 'right' }}>
                          <div className="radioButtonWrapper">
                            {/* Horizontal Radio Buttons */}
                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                id="drawnOfGovernmentLoansYes"
                                name="drawnOfGovernmentLoans"
                                value="Yes"
                                checked={formValues.drawnOfGovernmentLoans === 'Yes'}
                                onChange={handleInput}
                                disabled={readOnly}
                              />
                              <label htmlFor="drawnOfGovernmentLoansYes" className="form-label ms-0.9">Yes</label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                id="drawnOfGovernmentLoansNo"
                                name="drawnOfGovernmentLoans"
                                value="No"
                                checked={formValues.drawnOfGovernmentLoans === 'No'}
                                onChange={handleInput}
                                disabled={readOnly}
                              />
                              <label htmlFor="drawnOfGovernmentLoansNo" className="form-label ms-0.9">No</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Remarks Section - Always Visible for both Yes and No */}
                    <div id="switchRemarks15">
                      <label htmlFor="drawnOfGovernmentLoansRemarks" className="form-label">
                        If so, furnish details. <span className="text-danger">*</span>
                      </label>
                      <textarea
                        className="form-control"
                        value={formValues.drawnOfGovernmentLoansRemarks}
                        onChange={handleInput}
                        id="drawnOfGovernmentLoansRemarks"
                        name="drawnOfGovernmentLoansRemarks"
                        placeholder="Write here"
                        readOnly={readOnly}
                      />
                    </div>
                  </div>





                  {/* <div className="col-md-12">
                    <div className="container-fluid p-0">
                      <div className="row">
                        <div className="col-md-10">
                          <label for="selectionserialnumber" className="form-label">Whether he/she has served in the rural areas (PHC) as Civil Assistant Surgeon for a period of three years.</label>
                        </div>
                        <div className="col-md-2" style={{ "text-align": "right" }}>
                          <div className="switchButtonWrapper" onClick={() => toggleSwitch('switchButton16', 'switchStatus16', 'switchRemarks16', 'servedInRuralAreas')}>
                            <button id="switchButton16" className={formValues.servedInRuralAreas == 'Yes' ? 'switchButton active' : 'switchButton'}></button>
                            <span id="switchStatus16">{formValues.servedInRuralAreas ?? 'No'}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div id='switchRemarks16' className={formValues.servedInRuralAreas == 'Yes' ? '' : 'd-none'}>
                      <label for="selectionserialnumber" className="form-label">if so, Furnish details <span className="text-danger">*</span></label>
                      <textarea className="form-control" value={formValues.servedInRuralAreasRemarks} onChange={handleInput} id="servedInRuralAreasRemarks" name="servedInRuralAreasRemarks"
                        placeholder="write here" readOnly={readOnly}></textarea>
                    </div>
                  </div> */}

                  <div className="col-md-12">
                    <div className="container-fluid p-0">
                      <div className="row">
                        <div className="col-md-9">
                          <label htmlFor="servedInRuralAreas" className="form-label">
                            Whether he/she has served in the rural areas (PHC) as Civil Assistant Surgeon for a period of three years?
                          </label>
                        </div>
                        <div className="col-md-3" style={{ textAlign: 'right' }}>
                          <div className="radioButtonWrapper">
                            {/* Horizontal Radio Buttons */}
                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                id="servedInRuralAreasYes"
                                name="servedInRuralAreas"
                                value="Yes"
                                checked={formValues.servedInRuralAreas === 'Yes'}
                                onChange={handleInput}
                                disabled={readOnly}
                              />
                              <label htmlFor="servedInRuralAreasYes" className="form-label ms-0.9">Yes</label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                id="servedInRuralAreasNo"
                                name="servedInRuralAreas"
                                value="No"
                                checked={formValues.servedInRuralAreas === 'No'}
                                onChange={handleInput}
                                disabled={readOnly}
                              />
                              <label htmlFor="servedInRuralAreasNo" className="form-label ms-0.9">No</label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                id="servedInRuralAreasNo"
                                name="servedInRuralAreas"
                                value="NA"
                                checked={formValues.servedInRuralAreas === 'NA'}
                                onChange={handleInput}
                                disabled={readOnly}
                              />
                              <label htmlFor="servedInRuralAreasNA" className="form-label ms-0.9">NA</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Remarks Section - Always Visible for both Yes and No */}
                    <div id="switchRemarks16">
                      <label htmlFor="servedInRuralAreasRemarks" className="form-label">
                        If so, furnish details <span className="text-danger">*</span>
                      </label>
                      <textarea
                        className="form-control"
                        value={formValues.servedInRuralAreasRemarks}
                        onChange={handleInput}
                        id="servedInRuralAreasRemarks"
                        name="servedInRuralAreasRemarks"
                        placeholder="Write here"
                        readOnly={readOnly}
                      />
                    </div>
                  </div>


                  <div className="col-md-12">
                    <label for="selectionserialnumber" className="form-label">Permanent Address in India <span className="text-danger">*</span> </label>
                    <textarea className="form-control" onChange={handleInput} value={formValues.permanentAddress} id="permanentAddress" name="permanentAddress"
                      placeholder="write here" readOnly={readOnly}></textarea>
                  </div>
                  <div className="col-md-12">
                    <label for="selectionserialnumber" className="form-label">Address Abroad <span className="text-danger">*</span></label>
                    <textarea className="form-control" onChange={handleInput} value={formValues.addressAbroad} id="addressAbroad" name="addressAbroad"
                      placeholder="write here" readOnly={readOnly}></textarea>
                  </div>

                  <div className="col-md-6">
                    <label for="cityOfVisitAbroad" className="form-label">City of Visit Abroad <span className="text-danger">*</span> </label>
                    <textarea className="form-control" onChange={handleInput} value={formValues.cityOfVisitAborad} id="cityOfVisitAborad" name="cityOfVisitAborad"
                      placeholder="write here" readOnly={readOnly}></textarea>
                  </div>
                  <div className="col-md-6">
                    <label for="countryOfvisitAbroad" className="form-label">Country of visit abroad <span className="text-danger">*</span></label>
                    <textarea className="form-control" onChange={handleInput} value={formValues.countryOfvisitAbroad} id="countryOfvisitAbroad" name="countryOfvisitAbroad"
                      placeholder="write here" readOnly={readOnly}></textarea>
                  </div>

                  {/* <div className="col-md-12">
                    <div className="container-fluid p-0">
                      <div className="row">
                        <div className="col-md-10">
                          <label for="selectionserialnumber" className="form-label">Whether he/she has stood as a surety to any person who went abroad for higher studies or staying in India.</label>
                        </div>
                        <div className="col-md-2" style={{ "text-align": "right" }}>
                          <div className="switchButtonWrapper" onClick={() => toggleSwitch('switchButton17', 'switchStatus17', 'switchRemarks17', 'stoodAnyPersonWentAbroad')}>
                            <button id="switchButton17" className={formValues.stoodAnyPersonWentAbroad == 'Yes' ? 'switchButton active' : 'switchButton'}></button>
                            <span id="switchStatus17">{formValues.stoodAnyPersonWentAbroad ?? 'No'}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div id='switchRemarks17' className={formValues.stoodAnyPersonWentAbroad == 'Yes' ? '' : 'd-none'}>
                      <label for="selectionserialnumber" className="form-label">If so, give details<span className="text-danger">*</span></label>
                      <textarea className="form-control" onChange={handleInput} value={formValues.stoodAnyPersonWentAbroadRemarks} id="stoodAnyPersonWentAbroadRemarks" name="stoodAnyPersonWentAbroadRemarks"
                        placeholder="write here" readOnly={readOnly}></textarea>
                    </div>
                  </div> */}

                  <div className="col-md-12">
                    <div className="container-fluid p-0">
                      <div className="row">
                        <div className="col-md-10">
                          <label htmlFor="stoodAnyPersonWentAbroad" className="form-label">
                            Whether he/she has stood as a surety to any person who went abroad for higher studies or staying in India.
                          </label>
                        </div>
                        <div className="col-md-2" style={{ textAlign: 'right' }}>
                          <div className="radioButtonWrapper">
                            {/* Horizontal Radio Buttons */}
                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                id="stoodAnyPersonWentAbroadYes"
                                name="stoodAnyPersonWentAbroad"
                                value="Yes"
                                checked={formValues.stoodAnyPersonWentAbroad === 'Yes'}
                                onChange={handleInput}
                                disabled={readOnly}
                              />
                              <label htmlFor="stoodAnyPersonWentAbroadYes" className="form-label ms-0.9">Yes</label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                id="stoodAnyPersonWentAbroadNo"
                                name="stoodAnyPersonWentAbroad"
                                value="No"
                                checked={formValues.stoodAnyPersonWentAbroad === 'No'}
                                onChange={handleInput}
                                disabled={readOnly}
                              />
                              <label htmlFor="stoodAnyPersonWentAbroadNo" className="form-label ms-0.9">No</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Remarks Section - Always Visible for both Yes and No */}
                    <div id="switchRemarks17">
                      <label htmlFor="stoodAnyPersonWentAbroadRemarks" className="form-label">
                        If so, give details <span className="text-danger">*</span>
                      </label>
                      <textarea
                        className="form-control"
                        onChange={handleInput}
                        value={formValues.stoodAnyPersonWentAbroadRemarks}
                        id="stoodAnyPersonWentAbroadRemarks"
                        name="stoodAnyPersonWentAbroadRemarks"
                        placeholder="Write here"
                        readOnly={readOnly}
                      />
                    </div>
                  </div>

                  <div className="col-md-12">
                    <label for="selectionserialnumber" className="form-label">Remarks if any</label>
                    <textarea className="form-control" onChange={handleInput} value={formValues.remarks} id="remarks" name="remarks"
                      placeholder="write here" readOnly={readOnly}></textarea>
                  </div>

                </div>



              </div>
            </div>





          </div>


        </div>
        {!props.blockUploads && (
          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <h5 className="card-title mb-0">Employee Attachments</h5>
                    &nbsp;&nbsp;&nbsp;
                  </div>
                  &nbsp;&nbsp;
                  {props.application?.refId == undefined ?
                    <><div className="row g-3">
                      <div className="col-md-4">
                        <label for="candidatename" className="form-label">1. Employee Request Letter <span className="text-danger">*</span></label>
                      </div>
                      <div className="col-md-6">
                        <input className="form-control" onChange={handleFileUpload} type="file" id="1" />
                      </div>
                    </div>
                      <div className="row g-3">
                        <div className="col-md-4">
                          <label for="candidatename" className="form-label">2. Copy of Passport <span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-6">
                          <input className="form-control" onChange={handleFileUpload} type="file" id="2" />
                        </div>
                      </div>
                      <div className="row g-3">
                        <div className="col-md-4">
                          <label for="candidatename" onChange={handleFileUpload} className="form-label">3. Surety Bond <span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-6">
                          <input className="form-control" onChange={handleFileUpload} type="file" id="3" />
                        </div>
                      </div>

                      <div className="row g-3">
                        <div className="col-md-4">
                          <label for="candidatename" onChange={handleFileUpload} className="form-label"> 4. Certificate by The First Surety  <span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-6">
                          <input className="form-control" onChange={handleFileUpload} type="file" id="18" />
                        </div>
                      </div>
                      <div className="row g-3">
                        <div className="col-md-4">
                          <label for="candidatename" onChange={handleFileUpload} className="form-label">5. Latest Payslip of the First Surety  <span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-6">
                          <input className="form-control" onChange={handleFileUpload} type="file" id="19" />
                        </div>
                      </div>
                      <div className="row g-3">
                        <div className="col-md-4">
                          <label for="candidatename" onChange={handleFileUpload} className="form-label">6. Certificate by The Second Surety<span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-6">
                          <input className="form-control" onChange={handleFileUpload} type="file" id="20" />
                        </div>
                      </div>

                      <div className="row g-3">
                        <div className="col-md-4">
                          <label for="candidatename" onChange={handleFileUpload} className="form-label">7. Latest Payslip of the Second Surety <span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-6">
                          <input className="form-control" onChange={handleFileUpload} type="file" id="21" />
                        </div>
                      </div>

                      <h5 className="card-title">Documents obtained from DDO</h5>
                      <div className="row g-3">
                        <div className="col-md-4">
                          <label for="candidatename" className="form-label">8. DDO Covering Letter  <span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-6">
                          <input className="form-control" onChange={handleFileUpload} type="file" id="10" />
                        </div>

                      </div>

                      <div className="row g-3">
                        <div className="col-md-4">
                          <label for="candidatename" className="form-label">9. Certificate of Head of Department/Institution in 16 columns prescribed forma  <span className="text-danger">*</span> </label>
                        </div>
                        <div className="col-md-6">
                          <input className="form-control" onChange={handleFileUpload} type="file" id="5" />
                        </div>

                      </div>

                      <div className="row g-3">
                        <div className="col-md-4">
                          <label for="candidatename" className="form-label">10. No Charge Pending <span className="text-danger">*</span> </label>
                        </div>
                        <div className="col-md-6">
                          <input className="form-control" onChange={handleFileUpload} type="file" id="6" />
                        </div>

                      </div>
                      <div className="row g-3">
                        <div className="col-md-4">
                          <label for="candidatename" className="form-label">11. Service Satisfactory Certificate  <span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-6">
                          <input className="form-control" onChange={handleFileUpload} type="file" id="7" />
                        </div>

                      </div>
                      <div className="row g-3">
                        <div className="col-md-4">
                          <label for="candidatename" className="form-label">12. No Dues Certificate <span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-6">
                          <input className="form-control" onChange={handleFileUpload} type="file" id="8" />
                        </div>

                      </div>
                      <div className="row g-3">
                        <div className="col-md-4">
                          <label for="candidatename" className="form-label">13. Copy of Service Regularization And Probation Declaration  <span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-6">
                          <input className="form-control" onChange={handleFileUpload} type="file" id="9" />
                        </div>

                      </div>
                      <div className="row g-3">
                        <div className="col-md-4">
                          <label for="candidatename" className="form-label">14. Others</label>
                        </div>
                        <div className="col-md-6">
                          <input className="form-control" onChange={handleFileUpload} type="file" id="11" />
                        </div>
                      </div>

                    </> : formValues.fileList != undefined ? <>

                      <div className="row g-3">

                        <div className="col-md-4">
                          <label for="candidatename" className="form-label">Employee Request Letter</label>
                        </div>
                        <div className="col-md-6">
                          <Link onClick={() => viewPdf(formValues.fileList.find(item => item.attachType === "1")?.documentManagementId)} ><i className="fas fa-file-pdf fa-lg" style={{ color: 'red' }}></i> {/* PDF Icon */} </Link>
                          &nbsp;&nbsp;
                          <Link onClick={() => printPdf(formValues.fileList.find(item => item.attachType === "1")?.documentManagementId)}>
                            <i className="fas fa-print fa-lg" style={{ color: 'black' }}></i> {/* Print Icon */}
                          </Link>
                        </div>
                      </div>
                      <div className="row g-3">
                        <div className="col-md-4">
                          <label for="candidatename" className="form-label">Copy of Passport</label>
                        </div>
                        <div className="col-md-6">
                          <Link onClick={() => viewPdf(formValues.fileList.find(item => item.attachType === "2")?.documentManagementId)} ><i className="fas fa-file-pdf fa-lg" style={{ color: 'red' }}></i> {/* PDF Icon */} </Link>
                          &nbsp;&nbsp;
                          <Link onClick={() => printPdf(formValues.fileList.find(item => item.attachType === "2")?.documentManagementId)}>
                            <i className="fas fa-print fa-lg" style={{ color: 'black' }}></i> {/* Print Icon */}
                          </Link>

                        </div>
                      </div>
                      <div className="row g-3">
                        <div className="col-md-4">
                          <label for="candidatename" className="form-label">Surety Bond</label>
                        </div>
                        <div className="col-md-6">
                          <Link onClick={() => viewPdf(formValues.fileList.find(item => item.attachType === "3")?.documentManagementId)} ><i className="fas fa-file-pdf fa-lg" style={{ color: 'red' }}> </i> {/* PDF Icon */} </Link>
                          &nbsp;&nbsp;
                          <Link onClick={() => printPdf(formValues.fileList.find(item => item.attachType === "3")?.documentManagementId)}>
                            <i className="fas fa-print fa-lg" style={{ color: 'black' }}></i> {/* Print Icon */}
                          </Link>

                        </div>
                      </div>
                      {/* <div className="row g-3">
                        <div className="col-md-4">
                          <label for="candidatename" className="form-label">Any Other</label>
                        </div>
                        <div className="col-md-6">
                          // <Link onClick={() => viewPdf(formValues.fileList[3]?.documentManagementId)} ><i className="fas fa-file-pdf fa-lg" style={{ color: 'red' }}></i> {/* PDF Icon */}
                      {/* </Link>
                        </div>
                      </div>  */}
                      <div className="row g-3">
                        <div className="col-md-4">
                          <label for="candidatename" className="form-label">Certificate of Head of Department/Institution</label>
                        </div>
                        <div className="col-md-6">
                          <Link onClick={() => viewPdf(formValues.fileList.find(item => item.attachType === "5")?.documentManagementId)} ><i className="fas fa-file-pdf fa-lg" style={{ color: 'red' }}></i> {/* PDF Icon */} </Link>
                          &nbsp;&nbsp;
                          <Link onClick={() => printPdf(formValues.fileList.find(item => item.attachType === "5")?.documentManagementId)}>
                            <i className="fas fa-print fa-lg" style={{ color: 'black' }}></i> {/* Print Icon */}
                          </Link>

                        </div>
                      </div>
                      <div className="row g-3">
                        <div className="col-md-4">
                          <label for="candidatename" className="form-label">No Charge Pending </label>
                        </div>
                        <div className="col-md-6">
                          <Link onClick={() => viewPdf(formValues.fileList.find(item => item.attachType === "6")?.documentManagementId)} ><i className="fas fa-file-pdf fa-lg" style={{ color: 'red' }}></i> {/* PDF Icon */} </Link>
                          &nbsp;&nbsp;
                          <Link onClick={() => printPdf(formValues.fileList.find(item => item.attachType === "6")?.documentManagementId)}>
                            <i className="fas fa-print fa-lg" style={{ color: 'black' }}></i> {/* Print Icon */}
                          </Link>

                        </div>
                      </div>
                      <div className="row g-3">
                        <div className="col-md-4">
                          <label for="candidatename" className="form-label">Service Satisfactory Certificate</label>
                        </div>
                        <div className="col-md-6">
                          <Link onClick={() => viewPdf(formValues.fileList.find(item => item.attachType === "7")?.documentManagementId)} ><i className="fas fa-file-pdf fa-lg" style={{ color: 'red' }}></i> {/* PDF Icon */} </Link>
                          &nbsp;&nbsp;
                          <Link onClick={() => printPdf(formValues.fileList.find(item => item.attachType === "7")?.documentManagementId)}>
                            <i className="fas fa-print fa-lg" style={{ color: 'black' }}></i> {/* Print Icon */}
                          </Link>

                        </div>
                      </div>
                      <div className="row g-3">
                        <div className="col-md-4">
                          <label for="candidatename" className="form-label">No Dues Certificate</label>
                        </div>
                        <div className="col-md-6">
                          <Link onClick={() => viewPdf(formValues.fileList.find(item => item.attachType === "8")?.documentManagementId)} ><i className="fas fa-file-pdf fa-lg" style={{ color: 'red' }}></i> {/* PDF Icon */} </Link>
                          &nbsp;&nbsp;
                          <Link onClick={() => printPdf(formValues.fileList.find(item => item.attachType === "8")?.documentManagementId)}>
                            <i className="fas fa-print fa-lg" style={{ color: 'black' }}></i> {/* Print Icon */}
                          </Link>

                        </div>
                      </div>
                      <div className="row g-3">
                        <div className="col-md-4">
                          <label for="candidatename" className="form-label">Copy of Service Regularization And Probation Declaration </label>
                        </div>
                        <div className="col-md-6">
                          <Link onClick={() => viewPdf(formValues.fileList.find(item => item.attachType === "9")?.documentManagementId)} ><i className="fas fa-file-pdf fa-lg" style={{ color: 'red' }}></i> {/* PDF Icon */} </Link>
                          &nbsp;&nbsp;
                          <Link onClick={() => printPdf(formValues.fileList.find(item => item.attachType === "9")?.documentManagementId)}>
                            <i className="fas fa-print fa-lg" style={{ color: 'black' }}></i> {/* Print Icon */}
                          </Link>

                        </div>
                      </div>
                      <div className="row g-3">
                        <div className="col-md-4">
                          <label for="candidatename" className="form-label">DDO Covering Letter</label>
                        </div>
                        <div className="col-md-6">
                          <Link onClick={() => viewPdf(formValues.fileList.find(item => item.attachType === "10")?.documentManagementId)} ><i className="fas fa-file-pdf fa-lg" style={{ color: 'red' }}></i> {/* PDF Icon */} </Link>
                          &nbsp;&nbsp;
                          <Link onClick={() => printPdf(formValues.fileList.find(item => item.attachType === "")?.documentManagementId)}>
                            <i className="fas fa-print fa-lg" style={{ color: 'black' }}></i> {/* Print Icon */}
                          </Link>

                        </div>
                      </div>

                      <div className="row g-3">
                        <div className="col-md-4">
                          <label for="candidatename" className="form-label">Certificate by The First Surety</label>
                        </div>
                        <div className="col-md-6">
                          <Link onClick={() => viewPdf(formValues.fileList.find(item => item.attachType === "18")?.documentManagementId)} ><i className="fas fa-file-pdf fa-lg" style={{ color: 'red' }}></i> {/* PDF Icon */} </Link>
                          &nbsp;&nbsp;
                          <Link onClick={() => printPdf(formValues.fileList.find(item => item.attachType === "18")?.documentManagementId)}>
                            <i className="fas fa-print fa-lg" style={{ color: 'black' }}></i> {/* Print Icon */}
                          </Link>
                        </div>
                      </div>


                      <div className="row g-3">
                        <div className="col-md-4">
                          <label for="candidatename" className="form-label">Latest Payslip of the First Surety</label>
                        </div>
                        <div className="col-md-6">
                          <Link onClick={() => viewPdf(formValues.fileList.find(item => item.attachType === "19")?.documentManagementId)} ><i className="fas fa-file-pdf fa-lg" style={{ color: 'red' }}></i> {/* PDF Icon */} </Link>
                          &nbsp;&nbsp;
                          <Link onClick={() => printPdf(formValues.fileList.find(item => item.attachType === "19")?.documentManagementId)}>
                            <i className="fas fa-print fa-lg" style={{ color: 'black' }}></i> {/* Print Icon */}
                          </Link>

                        </div>
                      </div>


                      <div className="row g-3">
                        <div className="col-md-4">
                          <label for="candidatename" className="form-label">Certificate by The Second Surety</label>
                        </div>
                        <div className="col-md-6">
                          <Link onClick={() => viewPdf(formValues.fileList.find(item => item.attachType === "20")?.documentManagementId)} ><i className="fas fa-file-pdf fa-lg" style={{ color: 'red' }}></i> {/* PDF Icon */} </Link>
                          &nbsp;&nbsp;
                          <Link onClick={() => printPdf(formValues.fileList.find(item => item.attachType === "20")?.documentManagementId)}>
                            <i className="fas fa-print fa-lg" style={{ color: 'black' }}></i> {/* Print Icon */}
                          </Link>

                        </div>
                      </div>

                      <div className="row g-3">
                        <div className="col-md-4">
                          <label for="candidatename" className="form-label">Latest Payslip of the Second Surety</label>
                        </div>
                        <div className="col-md-6">
                          <Link onClick={() => viewPdf(formValues.fileList.find(item => item.attachType === "21")?.documentManagementId)} ><i className="fas fa-file-pdf fa-lg" style={{ color: 'red' }}></i> {/* PDF Icon */} </Link>
                          &nbsp;&nbsp;
                          <Link onClick={() => printPdf(formValues.fileList.find(item => item.attachType === "21")?.documentManagementId)}>
                            <i className="fas fa-print fa-lg" style={{ color: 'black' }}></i> {/* Print Icon */}
                          </Link>

                        </div>
                      </div>




                      {formValues.fileList.find(i => i.attachType === "11")?.documentManagementId && (
                        <div className="row g-3">
                          <div className="col-md-4">
                            <label htmlFor="candidatename" className="form-label">Others</label>
                          </div>
                          <div className="col-md-6">
                            <Link onClick={() => viewPdf(formValues.fileList.find(i => i.attachType === "11")?.documentManagementId)}>
                              <i className="fas fa-file-pdf fa-lg" style={{ color: 'red' }}></i> {/* PDF Icon */}
                              &nbsp;&nbsp;
                              <Link onClick={() => printPdf(formValues.fileList.find(i => i.attachType === "11")?.documentManagementId)}>
                                <i className="fas fa-print fa-lg" style={{ color: 'black' }}></i> {/* Print Icon */}
                              </Link>

                            </Link>
                          </div>
                        </div>
                      )}
                    </> : ''
                  }

                  <div className="d-flex justify-content-end mt-3">
                    {props.application?.refId !== undefined && (
                      <Link onClick={handleButtonClick} className="btn btn-primary">
                        <i className="fas fa-download fa-lg" style={{ color: 'white' }}></i> <span style={{ color: 'white' }}>Download All</span>
                      </Link>
                    )}
                  </div>

                </div>
              </div>


              {props.application?.refId != undefined ?
                <>
                  {sessionStorage.getItem('userRole') !== 'CD32' ? (
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="card">
                          <div className="card-body">

                            <div className="row g-3">
                              <div className="col-md-12">
                                <label for="candidatename" className="form-label">Remarks <span className="text-danger">*</span></label>
                                <input type="text" className="form-control" id="roleWiseRemarks" onChange={handleInput} name="remarks" />
                              </div>
                              <div className="col-md-12">
                                {formValues.durationOfStayAbroad <= 30 && sessionStorage.getItem('userRole') === 'CD3' && (
                                  <h6><b> NOC Approval </b></h6>
                                )}

                                {action && action.map((row, index) => (   //processtaskId is coming
                                  <div key={index} style={{ display: 'inline-block', marginBottom: '10px' }}> {/* Add space between radio buttons */}
                                    <input type="radio" onChange={handleInput} value={row.id} id={`actionId${index}`} name="actionId" />
                                    <label htmlFor={`actionId${index}`} style={{ marginLeft: '5px', marginRight: '10px' }}>{row.desc}</label> {/* Add space between input and label */}
                                  </div>
                                ))}


                              </div>

                            </div>
                          </div>


                        </div>
                      </div>

                    </div>
                  ) : ''}

                  {sessionStorage.getItem('userRole') === 'CD2' ? <div className="row">
                    <div className="col-lg-12">
                      <div className="card">
                        <div className="card-body">
                          {/* <h5 className="card-title">Proforma Particular</h5> */}
                          <div className="row g-3">
                            <div className="col-md-12">
                              <label for="attchddo" className="form-label"> Attachment for DO </label>
                            </div>
                            <div className="col-md-6">
                              <input className="form-control" onChange={handleFileUpload} type="file" id="12" />
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div> : ''}
                  {/* sessionStorage.getItem('userRole') === 'CD5' && formValues.actionId === '2' ? ( */}
                  {(sessionStorage.getItem('userRole') === 'CD3' && formValues.durationOfStayAbroad <= 30 && formValues.actionId === '2') ||
                    sessionStorage.getItem('userRole') === 'CD32' ? (

                    <div className="d-flex align-items-baseline justify-content-center">
                      <button type="button" onClick={handleDownload} className="btn  main-button">
                        Click here to download PDF
                      </button>
                    </div>
                  ) : ''}

                  {sessionStorage.getItem('userRole') === 'CD3' && formValues.actionId === '2' ? <div className="row">
                    <div className="col-lg-12">
                      <div className="card">
                        <div className="card-body">
                          {/* <h5 className="card-title">Proforma Particular</h5> */}
                          <div className="row g-3">
                            <div className="col-md-12">
                              <label for="attchddo" className="form-label">
                                {formValues.durationOfStayAbroad > 30 ? 'Attachment for HOD' : 'Attach NOC Approval Copy'}
                                {formValues.durationOfStayAbroad <= 30 && <span className="text-danger">*</span>}
                              </label>
                            </div>
                            <div className="col-md-6">
                              <input className="form-control" onChange={handleFileUpload} type="file"
                                id={formValues.durationOfStayAbroad > 30 ? "13" : "25"}
                              />
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div> : ''}

                  {sessionStorage.getItem('userRole') === 'CD4' && formValues.actionId !== '4' ? <div className="row">
                    <div className="col-lg-12">
                      <div className="card">
                        <div className="card-body">
                          {/* <h5 className="card-title">Proforma Particular</h5> */}
                          <div className="row g-3">
                            <div className="col-md-12">
                              <label for="attchddo" className="form-label"> Attachment for JS </label>
                            </div>
                            <div className="col-md-6">
                              <input className="form-control" onChange={handleFileUpload} type="file" id="14" />
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div> : ''}

                  {/* sessionStorage.getItem('userRole') === 'CD5'  */}
                  {sessionStorage.getItem('userRole') === 'CD32' ? <div className="row">
                    <div className="col-lg-12">
                      <div className="card">
                        <div className="card-body">
                          {/* <h5 className="card-title">Proforma Particular</h5> */}
                          <div className="row g-3">
                            <div className="col-md-12">
                              <label for="attchddo" className="form-label"> Attach NOC final approval copy  <span className="text-danger">*</span></label>
                            </div>
                            <div className="col-md-6">
                              <input className="form-control" onChange={handleFileUpload} type="file" id="25" />

                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div> : ''}
                </> : ''}


              {((sessionStorage.getItem('userRole') === 'CD3' || sessionStorage.getItem('userRole') === 'CD4' || sessionStorage.getItem('userRole') === 'CD33') && formValues.actionId === '4') ? (
                <div className="d-flex align-items-baseline justify-content-center">
                  <button type="button" onClick={handleReturnDownload} className="btn  main-button">
                    Click here to download  the Rejected PDF
                  </button>
                </div>
              ) : ''}

              {formValues.actionId === '4' && (sessionStorage.getItem('userRole') === 'CD3' || sessionStorage.getItem('userRole') === 'CD4' || sessionStorage.getItem('userRole') === 'CD26') ? <div className="row">
                <div className="col-lg-12">
                  <div className="card">
                    <div className="card-body">
                      {/* <h5 className="card-title">Proforma Particular</h5> */}
                      <div className="row g-3">
                        <div className="col-md-12">
                          <label for="attchddo" className="form-label"> Attach NOC Returned copy  <span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-6">
                          <input className="form-control" onChange={handleFileUpload} type="file" id="25" />

                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div> : ''}






            </div>


          </div>
        )}

        {formValues.fileList !== undefined && props.blockUploads === true ? (
          <div>
            <div className="row g-3">
              <div className="col-md-4">
                <label for="candidatename" className="form-label">Employee Request Letter</label>
              </div>
              <div className="col-md-6">
                <Link onClick={() => viewPdf(formValues.fileList.find(item => item.attachType === "1")?.documentManagementId)}>
                  <i className="fas fa-file-pdf fa-lg" style={{ color: 'red' }}></i> {/* PDF Icon */}
                </Link>
                &nbsp;&nbsp;
                <Link onClick={() => printPdf(formValues.fileList.find(item => item.attachType === "1")?.documentManagementId)}>
                  <i className="fas fa-print fa-lg" style={{ color: 'black' }}></i> {/* Print Icon */}
                </Link>
              </div>
            </div>

            <div className="row g-3">
              <div className="col-md-4">
                <label for="candidatename" className="form-label">Copy of Passport</label>
              </div>
              <div className="col-md-6">
                <Link onClick={() => viewPdf(formValues.fileList.find(item => item.attachType === "2")?.documentManagementId)}>
                  <i className="fas fa-file-pdf fa-lg" style={{ color: 'red' }}></i> {/* PDF Icon */}
                </Link>
                &nbsp;&nbsp;
                <Link onClick={() => printPdf(formValues.fileList.find(item => item.attachType === "2")?.documentManagementId)}>
                  <i className="fas fa-print fa-lg" style={{ color: 'black' }}></i> {/* Print Icon */}
                </Link>
              </div>
            </div>

            <div className="row g-3">
              <div className="col-md-4">
                <label for="candidatename" className="form-label">Surety Bond</label>
              </div>
              <div className="col-md-6">
                <Link onClick={() => viewPdf(formValues.fileList.find(item => item.attachType === "3")?.documentManagementId)}>
                  <i className="fas fa-file-pdf fa-lg" style={{ color: 'red' }}></i> {/* PDF Icon */}
                </Link>
                &nbsp;&nbsp;
                <Link onClick={() => printPdf(formValues.fileList.find(item => item.attachType === "3")?.documentManagementId)}>
                  <i className="fas fa-print fa-lg" style={{ color: 'black' }}></i> {/* Print Icon */}
                </Link>
              </div>
            </div>
            <div className="row g-3">
              <div className="col-md-4">
                <label for="candidatename" className="form-label">Certificate by The First Surety</label>
              </div>
              <div className="col-md-6">
                <Link onClick={() => viewPdf(formValues.fileList.find(item => item.attachType === "18")?.documentManagementId)}>
                  <i className="fas fa-file-pdf fa-lg" style={{ color: 'red' }}></i> {/* PDF Icon */}
                </Link>
                &nbsp;&nbsp;
                <Link onClick={() => printPdf(formValues.fileList.find(item => item.attachType === "18")?.documentManagementId)}>
                  <i className="fas fa-print fa-lg" style={{ color: 'black' }}></i> {/* Print Icon */}
                </Link>
              </div>
            </div>

            <div className="row g-3">
              <div className="col-md-4">
                <label for="candidatename" className="form-label">Latest Payslip of the First Surety</label>
              </div>
              <div className="col-md-6">
                <Link onClick={() => viewPdf(formValues.fileList.find(item => item.attachType === "19")?.documentManagementId)} ><i className="fas fa-file-pdf fa-lg" style={{ color: 'red' }}></i> {/* PDF Icon */} </Link>
                &nbsp;&nbsp;
                <Link onClick={() => printPdf(formValues.fileList.find(item => item.attachType === "19")?.documentManagementId)}>
                  <i className="fas fa-print fa-lg" style={{ color: 'black' }}></i> {/* Print Icon */}
                </Link>

              </div>
            </div>


            <div className="row g-3">
              <div className="col-md-4">
                <label for="candidatename" className="form-label">Certificate by The Second Surety</label>
              </div>
              <div className="col-md-6">
                <Link onClick={() => viewPdf(formValues.fileList.find(item => item.attachType === "20")?.documentManagementId)} ><i className="fas fa-file-pdf fa-lg" style={{ color: 'red' }}></i> {/* PDF Icon */} </Link>
                &nbsp;&nbsp;
                <Link onClick={() => printPdf(formValues.fileList.find(item => item.attachType === "20")?.documentManagementId)}>
                  <i className="fas fa-print fa-lg" style={{ color: 'black' }}></i> {/* Print Icon */}
                </Link>

              </div>
            </div>

            <div className="row g-3">
              <div className="col-md-4">
                <label for="candidatename" className="form-label">Latest Payslip of the Second Surety</label>
              </div>
              <div className="col-md-6">
                <Link onClick={() => viewPdf(formValues.fileList.find(item => item.attachType === "21")?.documentManagementId)} ><i className="fas fa-file-pdf fa-lg" style={{ color: 'red' }}></i> {/* PDF Icon */} </Link>
                &nbsp;&nbsp;
                <Link onClick={() => printPdf(formValues.fileList.find(item => item.attachType === "21")?.documentManagementId)}>
                  <i className="fas fa-print fa-lg" style={{ color: 'black' }}></i> {/* Print Icon */}
                </Link>

              </div>
            </div>

            <div className="row g-3">
              <div className="col-md-4">
                <label for="candidatename" className="form-label">DDO Covering Letter</label>
              </div>
              <div className="col-md-6">
                <Link onClick={() => viewPdf(formValues.fileList.find(item => item.attachType === "10")?.documentManagementId)}>
                  <i className="fas fa-file-pdf fa-lg" style={{ color: 'red' }}></i> {/* PDF Icon */}
                </Link>
                &nbsp;&nbsp;
                <Link onClick={() => printPdf(formValues.fileList.find(item => item.attachType === "10")?.documentManagementId)}>
                  <i className="fas fa-print fa-lg" style={{ color: 'black' }}></i> {/* Print Icon */}
                </Link>
              </div>
            </div>
            <div className="row g-3">
              <div className="col-md-4">
                <label for="candidatename" className="form-label">Certificate of Head of Department/Institution</label>
              </div>
              <div className="col-md-6">
                <Link onClick={() => viewPdf(formValues.fileList.find(item => item.attachType === "5")?.documentManagementId)}>
                  <i className="fas fa-file-pdf fa-lg" style={{ color: 'red' }}></i> {/* PDF Icon */}
                </Link>
                &nbsp;&nbsp;
                <Link onClick={() => printPdf(formValues.fileList.find(item => item.attachType === "5")?.documentManagementId)}>
                  <i className="fas fa-print fa-lg" style={{ color: 'black' }}></i> {/* Print Icon */}
                </Link>
              </div>
            </div>

            <div className="row g-3">
              <div className="col-md-4">
                <label for="candidatename" className="form-label">No Charge Pending</label>
              </div>
              <div className="col-md-6">
                <Link onClick={() => viewPdf(formValues.fileList.find(item => item.attachType === "6")?.documentManagementId)}>
                  <i className="fas fa-file-pdf fa-lg" style={{ color: 'red' }}></i> {/* PDF Icon */}
                </Link>
                &nbsp;&nbsp;
                <Link onClick={() => printPdf(formValues.fileList.find(item => item.attachType === "6")?.documentManagementId)}>
                  <i className="fas fa-print fa-lg" style={{ color: 'black' }}></i> {/* Print Icon */}
                </Link>
              </div>
            </div>

            <div className="row g-3">
              <div className="col-md-4">
                <label for="candidatename" className="form-label">Service Satisfactory Certificate</label>
              </div>
              <div className="col-md-6">
                <Link onClick={() => viewPdf(formValues.fileList.find(item => item.attachType === "7")?.documentManagementId)}>
                  <i className="fas fa-file-pdf fa-lg" style={{ color: 'red' }}></i> {/* PDF Icon */}
                </Link>
                &nbsp;&nbsp;
                <Link onClick={() => printPdf(formValues.fileList.find(item => item.attachType === "7")?.documentManagementId)}>
                  <i className="fas fa-print fa-lg" style={{ color: 'black' }}></i> {/* Print Icon */}
                </Link>
              </div>
            </div>

            <div className="row g-3">
              <div className="col-md-4">
                <label for="candidatename" className="form-label">No Dues Certificate</label>
              </div>
              <div className="col-md-6">
                <Link onClick={() => viewPdf(formValues.fileList.find(item => item.attachType === "8")?.documentManagementId)}>
                  <i className="fas fa-file-pdf fa-lg" style={{ color: 'red' }}></i> {/* PDF Icon */}
                </Link>
                &nbsp;&nbsp;
                <Link onClick={() => printPdf(formValues.fileList.find(item => item.attachType === "8")?.documentManagementId)}>
                  <i className="fas fa-print fa-lg" style={{ color: 'black' }}></i> {/* Print Icon */}
                </Link>
              </div>
            </div>

            <div className="row g-3">
              <div className="col-md-4">
                <label for="candidatename" className="form-label">Copy of Service Regularization And Probation Declaration</label>
              </div>
              <div className="col-md-6">
                <Link onClick={() => viewPdf(formValues.fileList.find(item => item.attachType === "9")?.documentManagementId)}>
                  <i className="fas fa-file-pdf fa-lg" style={{ color: 'red' }}></i> {/* PDF Icon */}
                </Link>
                &nbsp;&nbsp;
                <Link onClick={() => printPdf(formValues.fileList.find(item => item.attachType === "9")?.documentManagementId)}>
                  <i className="fas fa-print fa-lg" style={{ color: 'black' }}></i> {/* Print Icon */}
                </Link>
              </div>
            </div>
            {formValues.fileList.find(i => i.attachType === "11")?.documentManagementId && (
              <div className="row g-3">
                <div className="col-md-4">
                  <label htmlFor="candidatename" className="form-label">Others</label>
                </div>
                <div className="col-md-6">
                  <Link onClick={() => viewPdf(formValues.fileList.find(i => i.attachType === "11")?.documentManagementId)}>
                    <i className="fas fa-file-pdf fa-lg" style={{ color: 'red' }}></i> {/* PDF Icon */}
                    &nbsp;&nbsp;
                    <Link onClick={() => printPdf(formValues.fileList.find(i => i.attachType === "11")?.documentManagementId)}>
                      <i className="fas fa-print fa-lg" style={{ color: 'black' }}></i> {/* Print Icon */}
                    </Link>

                  </Link>
                </div>
              </div>
            )}

            <div className="d-flex justify-content-end mt-3">
              <Link onClick={handleButtonClick} className="btn btn-primary">
                <i className="fas fa-download fa-lg" style={{ color: 'white' }}></i> <span style={{ color: 'white' }}>Download All</span>
              </Link>

            </div>

          </div>
        ) : null}


        {/* {props.application?.refId == undefined ? <div className="row g-3">
          <div className="text-center">
            <button type="button" onClick={saveData} className="btn btn-primary">Submit</button>
          </div>
        </div> : <div className="text-center">
          <button type="button" onClick={saveApproveData} className="btn btn-primary">Submit</button>
        </div>} */}
        {!props.blockUploads && (
          props.application?.refId === undefined ? (
            <div className="row g-3">
              <div className="text-center">
                <button type="button" onClick={saveData} className="btn btn-primary">Submit</button>
              </div>
            </div>
          ) : (
            <div className="text-center">
              <button type="button" onClick={saveApproveData} className="btn btn-primary">Submit</button>
            </div>
          )
        )}



        <ModalComp
          size={"lg"}
          show={pdfView}
          handleClose={pdfViewClosed}
          modalTitle={"Document"}
          modalBody={<iframe
            title="PDF Viewer"
            src={pdfUrl}
            width="100%"
            height="500px"
            style={{ border: 'none' }}
          />}
        />

      </section >




    </>
  );
}

export default NocForm;
